// Testo localizzato dei bottoni (da theme.strings in theme.liquid); fallback = testo storico EN.
function wcStr(k, fallback){ try { var s = window.theme && window.theme.strings && window.theme.strings[k]; return s || fallback } catch(e){ return fallback } }
var loadScript = function(url, callback){
};

// Locale root (es. "" sulla lingua primaria, "/ja" o "/en" sulle secondarie).
// Serve a chiamare l'endpoint .js del prodotto nella STESSA lingua della pagina,
// altrimenti option1/option2 tornano nella lingua di default e non combaciano
// con i valori renderizzati da Liquid (colore selezionato, attr-value taglie).
var MR_LOCALE_ROOT = (window.__shopLocaleRoot || '/').replace(/\/+$/, '');

// Ridimensiona un'immagine Shopify CDN via query param width (fallback sicuro
// su URL non-Shopify: il parametro viene semplicemente ignorato).
function mrResizeImg(src, w){
  if (!src) return src;
  return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
}

// FINDER *****************************************************************************************************************************************************************
var finder = function($){

  // var tag_ricerca = ["Mens", "Black", "Freestyle"]

  

  var tag_ricerca = []
  var prodotti_trovati = []
  
  var step_successivo = false

  window.finder_opened = false;

  window.gender_tag = "";
  window.boot_size = "";
  window.boot_size__type = "mondo";
  window.level_tag = "";
  window.style_tag = "";

  // tag ricerca size (step 1.1) - GENDER
  $(".gender-step .tag_ricerca").on("click", function() {

    gender_tag = $(this).attr("attr-filter")

    $(".tag_find_size__type--us").attr("attr-find", "us-" + gender_tag.toLowerCase())
    $(".find-size__group").attr("attr-find", gender_tag)

    $(".gender-step .tag_ricerca").removeClass("selected")
    $(this).addClass("selected")
    $(this).prependTo(".gender-step")

    if ($(this).parent().hasClass("open")) {
      $(this).parent().find("i.fa-chevron-down").removeClass("open")
      $(this).parent().removeClass("open")
    } 
    // $(this).find(".select-style__single--select").remove()

    // console.log("Gender: "+gender_tag)

    $(".section-finder .tag_find_size__num").each(function(){
      var tag_num__gender = $(this).attr("attr-gender")
      var tag_num__type = $(this).attr("attr-type")

      if ( tag_num__gender !== gender_tag) {
        // console.log(tag_num__gender+" nascondo")
        $(this).addClass("hide")
      } else {
        $(this).removeClass("hide")
        // console.log(tag_num__gender+" mostro")
        if (tag_num__type !== boot_size__type) {
          $(this).addClass("hide")
        }
      }
      
    })

    // only for next button color
    if( (boot_size.length !== 0) && (gender_tag.length !== 0) ) {
      $(".foot__after.finder-next a.cta cta-black").addClass("active")
    } else {
      $(".foot__after.finder-next a.cta cta-black").removeClass("active")
    }

    setTimeout(function(){ 
      $(".gender-selection .select-style .fa-chevron-down.open").removeClass("open")
      $(".gender-selection .select-style.open").removeClass("open")
    }, 250);

  })
  
  // tag ricerca size (step 1.2) - BOOT SIZE TYPE
  $(".boot-size-selection .square-size").on("click", function() {

    boot_size = $(this).attr("attr-value")

    // only for next button color
    if( (boot_size.length !== 0) && (gender_tag.length !== 0) ) {
      $(".foot__after.finder-next a.cta cta-black").addClass("active")
    } else {
      $(".foot__after.finder-next a.cta cta-black").removeClass("active")
    }

  })

  // tag ricerca level (step 2)
  $(".level-step .tag_ricerca").on("click", function() {

    level_tag = $(this).attr("attr-filter")

    $(".level-step .tag_ricerca").removeClass("selected")
    $(this).addClass("selected")

    $(".level-step img.select-y").addClass("hide")
    $(".level-step img.select-n").removeClass("hide")
    $(this).find("img.select-y").removeClass("hide")
    $(this).find("img.select-n").addClass("hide")
    
  })

  // tag ricerca style (step 3)
  $(".style-step .tag_ricerca").on("click", function() {

    style_tag = $(this).attr("attr-filter")

    $(".style-step .tag_ricerca").removeClass("selected")
    $(this).addClass("selected")
    
  })


  // finder navigation
  $(".foot__pre").on("click", function(){

    var cur_step = $(".section-finder-box__step.selected").attr("attr-step")

    $(".foot__after").removeClass("disabled")

    new_step = parseInt(cur_step)
    new_step--

    if(new_step == 1) {
      $(".foot__pre").addClass("disabled")
    } else {
      $(".foot__pre").removeClass("disabled")
    }

    if(new_step == 4) {
      $(".foot__after").addClass("disabled")
    } else {
      $(".foot__after").removeClass("disabled")
    }

    if (new_step > 0) {
      $(".section-finder-box__step.selected").removeClass("selected")
      $(".foot__navigation i").removeClass("selected")
      $(".section-finder-box__step[attr-step='"+new_step+"']").addClass("selected")
      $(".foot__navigation i[attr-step='"+new_step+"']").addClass("selected")
    }

  })

  $(".foot__after").on("click", function(){

      var cur_step = $(".section-finder-box__step.selected").attr("attr-step")
      
      new_step = parseInt(cur_step)
      new_step++

      if (new_step == 2) {
        if( (boot_size.length !== 0) && (gender_tag.length !== 0) ) {
          step_successivo = true
          $(".foot__pre").removeClass("disabled")
        } else {
          step_successivo = false
          $(".error-field-compile").addClass("show")
          setTimeout(function(){ 
            $(".error-field-compile").removeClass("show")
          }, 1500);
        }
      }
      if (new_step == 3) {
        if ( level_tag.length !== 0)  {
          step_successivo = true
          $(".foot__pre").removeClass("disabled")
        } else {
          step_successivo = false
          $(".error-field-compile").addClass("show")
          setTimeout(function(){ 
            $(".error-field-compile").removeClass("show")
          }, 1500);
        }
      }
    
      // START STEP 4 - RISULTATI
      if (new_step == 4) {

        if ( style_tag.length !== 0)  {
          step_successivo = true
          $(".foot__pre").removeClass("disabled")
        } else {
          step_successivo = false
        }

        if (step_successivo) {
          $(".foot__after").addClass("disabled")
    
          // azzero i risultati
          $(".result-step").html("");
          $(".loader").removeClass("hide")
          prodotti_trovati = []
          // tag_ricerca = []
          // tag_ricerca.push(gender_tag,boot_size,level_tag,style_tag)
          // numero_tag_da_ricercare = tag_ricerca.length

          if (boot_size == "Small") {
            boot_size__convert = "Small"
          } else if (boot_size == "Medium") {
            boot_size__convert = "Medium"
          } else if (boot_size == "Large") {
            boot_size__convert = "Large"
          } else if ((boot_size == "ExtraLarge") || (boot_size == "X-Large") || (boot_size == "Extra Large")) {
            boot_size__convert = "Extra Large"
          } else if ((boot_size == "ExtraSmall") || (boot_size == "X-Small") || (boot_size == "")) {
            boot_size__convert = "Extra Small"
          } else if (boot_size == "OSFM") {
            boot_size__convert = "OSFM"
          } else if (boot_size == "Mini") {
            boot_size__convert = "Mini"
          } else if (boot_size == "One") {
            boot_size__convert = "One"
          } else if (boot_size == "154") {
            boot_size__convert = "154"
          } else if (boot_size == "157") {
            boot_size__convert = "157"
          } else if (boot_size == "160") {
            boot_size__convert = "160"
          }

          // if (( level_tag == "Intermediate" ) || ( level_tag == "Intermediate" )) {
          //   var level_tag_tosearch = "Intermediate--Advanced"
          // } else {
          //   var level_tag_tosearch = level_tag
          // }
    
          var combination_to_search = gender_tag+","+level_tag+","+style_tag

          // console.log(combination_to_search)

          //chiamata asincrona verso il file che contiene un json degli attacchi con i tag
          jQuery.ajax({
            url:"/pages/finder-list?view=finder.json", 
            success:function(products_comb){
        
              var list_comb = JSON.parse(products_comb)
    
              for (var combination of Object.keys(list_comb)) {

                if ( combination == combination_to_search ) {
                  // console.log("trovato" + combination)
                  var scelta1 = list_comb[combination][0]
                  var scelta2 = list_comb[combination][1]
                }
  
              //   products_list[products].forEach((combination_single,cs) => { 
                  
              //     if(combination_to_search == combination_single) {
              //       console.log("trovati: "+products)
              //       $(".find-size .square-size").addClass("hide")
              //       $(".find-size .square-size[attr-value='"+size_single+"']").removeClass("hide")     
              //     } 
              //   })
              }


    
              // // ciclo ogni attacco del json
              // for (var nome_attacco of Object.keys(products_list)) {
                
              //   numero_tag_trovati = 0
                
              //   // per ogni tag del signolo attacco che sto ciclando
              //   products_list[nome_attacco].forEach((tag_singolo,ts) => { 
              //     // cicla i tag di ricerca
              //     tag_ricerca.forEach((tag_ricerca_singolo,trs) => {
              //       // se corrispondono allora l'attacco ha quel tag
              //       if (tag_ricerca_singolo == tag_singolo) {
              //         numero_tag_trovati++
              //       }
              //     })
              //   });
              //   // aggiungo agli attacchi trovati solo se l'attacco ha tutti i tag corrispondenti ai tag di ricerca
              //   if ( numero_tag_trovati == numero_tag_da_ricercare) {
              //     prodotti_trovati.push(nome_attacco)
              //   }
              // }
                  
              $(".loader").addClass("hide")
    
              // if (prodotti_trovati.length == 0) {
              //   $('.result-step').append("<p class='no-product-find'>Nessun prodotto trovato.<br/>Prova a modificare i paramentri di ricerca.</p>");
              // } else {
    
                // stampo i risultati
    
                function print_product(prodotto_singolo_trovato, img_choice) {
                  jQuery.getJSON(MR_LOCALE_ROOT+'/products/'+prodotto_singolo_trovato+'.js', function(product) {
                    
                    var colors = []
                    var n_colors = 0
                    var color_list_box = ""
    
                    product.options.forEach((option) => {
    
                      if ( option.name == "Color" ) {
    
                        option.values.forEach((color => {
                          if ( color == "Race Red" ) { var back_round_col = "#EE2737" }
                          else if ( color == "Acid Green" ) { var back_round_col = "#dde61f" }
                          else if ( color == "Aqua" ) { var back_round_col = "#73ddd3" }
                          else if ( color == "Blue" ) { var back_round_col = "#a2c5d3" }
                          else if ( color == "Bluebell" ) { var back_round_col = "#7c94de" }
                          else if ( color == "Bone White" ) { var back_round_col = "#e3e1db" }
                          else if ( color == "Bronze" ) { var back_round_col = "#8b7866" }
                          else if ( color == "Bryan Iguchi" ) { var back_round_col = "#5781a6" }
                          else if ( color == "Burgundy" ) { var back_round_col = "#a80034" }
                          else if ( color == "Coral" ) { var back_round_col = "#ff5a5a" }
                          else if ( color == "Green" ) { var back_round_col = "#4a848d" }
                          else if ( color == "Gunmetal" ) { var back_round_col = "#596065" }
                          else if ( color == "Hot Pink" ) { var back_round_col = "#e31d94" }
                          else if ( color == "Hot Red" ) { var back_round_col = "#f8384b" }
                          else if ( color == "Jib Gurl" ) { var back_round_col = "#231f20" }
                          else if ( color == "Lavender" ) { var back_round_col = "#c5b1de" }
                          else if ( color == "Light Blue" ) { var back_round_col = "#c7d2ec" }
                          else if ( color == "Magenta" ) { var back_round_col = "#e00d5b" }
                          else if ( color == "Metallic Black" ) { var back_round_col = "#231f20" }
                          else if ( color == "Metallic Blue" ) { var back_round_col = "#185da4" }
                          else if ( color == "Metallic Purple" ) { var back_round_col = "#645a9a" }
                          else if ( color == "Metallic Red" ) { var back_round_col = "#b52d36" }
                          else if ( color == "Metallic White" ) { var back_round_col = "#f0f0f0" }
                          else if ( color == "Olive" ) { var back_round_col = "#606356" }
                          else if ( color == "Mustard" ) { var back_round_col = "#d69b2d" }
                          else if ( color == "Olive Green" ) { var back_round_col = "#888e64" }
                          else if ( color == "Purple" ) { var back_round_col = "#5b4d63" }
                          else if ( color == "Red" ) { var back_round_col = "#e80029" }
                          else if ( color == "Sage Green" ) { var back_round_col = "#5d7261" }
                          else if ( color == "Sand" ) { var back_round_col = "#907e6d" }
                          else if ( color == "Silver" ) { var back_round_col = "#a8abad" }
                          else if ( color == "Teal" ) { var back_round_col = "#006471" }
                          else if ( color == "Tie Dye" ) { var back_round_col = "#a7c6cb" }
                          else if ( color == "Violet" ) { var back_round_col = "#938695" }
                          else if ( color == "Yellow" ) { var back_round_col = "#e3e28d" }
                          else if ( color == "Black" ) { var back_round_col = "#000000" }
                          else if ( color == "White" ) { var back_round_col = "#f2f2f2" }
                          else if ( color == "Metallic Silver" ) { var back_round_col = "#aaadad" }
                          else if ( color == "Asadachi" ) { var back_round_col = "#dcb9a0" }
                          else if ( color == "Desert Camo" ) { var back_round_col = "#c8c1bb" }
                          else if ( color == "Orange" ) { var back_round_col = "#ff5300" }
                          else if ( color == "Cyan" ) { var back_round_col = "#2DCCD3" }
                          else if ( color == "Lilac" ) { var back_round_col = "#d4c1d8" }
                          else if ( color == "Seafoam Green" ) { var back_round_col = "#D6E6DF" }
                          else if ( color == "Hunter Orange" ) { var back_round_col = "#F93822" }
                          else if ( color == "Dark Green" ) { var back_round_col = "#59563E" }
                          else if ( color == "Pink B4BC" ) { var back_round_col = "#DCA9BF" }
                          else if ( color == "Royal Blue" ) { var back_round_col = "#003087" }
                          else if ( color == "Tangerine" ) { var back_round_col = "#FAAA8D" }
                          else if ( color == "Flame Orange" ) { var back_round_col = "#fc4c02" }
                          else if ( color == "Brown" ) { var back_round_col = "#837773" }
                          else if ( color == "Grey" ) { var back_round_col = "#d8e1e9" }
                          else if ( color == "Pink" ) { var back_round_col = "#d0a0ba" }
                          else if ( color == "Team" ) { var back_round_col = "#dadada" }
                          else if ( color == "Blue Flames" ) { var back_round_col = "#2256b8" }
                          else if ( color == "Tie Dye (B4BC)" ) { var back_round_col = "#d4c1d8" }
                          else if ( color == "Chrome" ) { var back_round_col = "#808080" }
                          else if ( color == "White/Orange" ) { var back_round_col = "#e56d03" }
                          else if ( color == "Black 20-YR" ) { var back_round_col = "#2D2926" }
                          else if ( color == "White 20-YR" ) { var back_round_col = "#F4F5F0" }
                          else if ( color == "Army Green" ) { var back_round_col = "#59563e" }
                          else if ( color == "Cyber Lime" ) { var back_round_col = "#b7bf10" }
                          else if ( color == "Rose" ) { var back_round_col = "#dea39c" }
                          else if ( color == "Bone" ) { var back_round_col = "#e4e2db" }
                          else if ( color == "Camo" ) { var back_round_col = "#59563f" }
                          else if ( color == "Sand Pink" ) { var back_round_col = "#dbcdd3" }
                          else if ( color == "Ice Grey" ) { var back_round_col = "#d3cfd9" }
                          else if ( color == "Sage" ) { var back_round_col = "#c6d6d0" }
                          else if ( color == "Jess Kimura" ) { var back_round_col = "#59563e" }
                          else if ( color == "Grey Violet" ) { var back_round_col = "#a37a8e" }
                          else if ( color == "Midnight" ) { var back_round_col = "#2c2a29" }
                          else if ( color == "Black / Orange" ) { var back_round_col = "#ff9800" }
                          else if ( color == "Black / Black" ) { var back_round_col = "#2D2926" }
                          else if ( color == "FC Black" ) { var back_round_col = "#000000" }
                          else if ( color == "Pikachu" ) { var back_round_col = "#f6eb61" }
                          else if ( color == "Khaki" ) { var back_round_col = "#C3B091" }
                          else if ( color == "Heather Grey" ) { var back_round_col = "#dadada" }
                          else if ( color == "Zinc White" ) { var back_round_col = "#F9F9F9" }
                          else if ( color == "Kazu Kokubo" ) { var back_round_col = "#b62e36" }
                          else if ( color == "Tye Dye" ) { var back_round_col = "#9fc1ea" }
                          else if ( color == "Stone" ) { var back_round_col = "#cccfce" }
                          else if ( color == "Bianco" ) { var back_round_col = "#f2f2f2" }
                          else if ( color == "Glacier Shadow" ) { var back_round_col = "#dcebe5" }
                          else if ( color == "Neon Yellow" ) { var back_round_col = "#dddd2c" }
                          else if ( color == "Blue-Grey" ) { var back_round_col = "#7697ac" }
                          else if ( color == "Cool Grey" ) { var back_round_col = "#d6d7d5" }
                          else if ( color == "Kevin Backstrom" ) { var back_round_col = "#e4e0db" }
                          else if ( color == "Tactical Green" ) { var back_round_col = "#62665c" }
                          else if ( color == "Cosmo" ) { var back_round_col = "#142c66" }
                          else if ( color == "Light Grey" ) { var back_round_col = "#d8e1e9" }
                          else if ( color == "Ice Blue" ) { var back_round_col = "#a7c6cb" }
                          else if ( color == "Dark Blue" ) { var back_round_col = "#4c748c" }
                          else if ( color == "B4BC" ) { var back_round_col = "#bfa4b9" }
                          else if ( color == "Spring Break" ) { var back_round_col = "#fd9cb1" }
                          else if ( color == "Tan" ) { var back_round_col = "#494835" }
                          else if ( color == "Mauve" ) { var back_round_col = "#868098" }
                          else { var back_round_col = "#000" }

    
                          color_list_box +=
                            `        
                            <span class="round-color" attr-value="`+option.values+`" style="background-color:`+back_round_col+`;">
                              <i class="fas fa-check hide"></i>
                            </span>
                            `
                          colors.push(back_round_col)
                          n_colors = option.values.length
    
                        }))
                        
                      }
                    })
    
                    if ( n_colors > 1) {
                      var text_color = "Available Colorways"
                    } else {
                      var text_color = "Available Colorway"
                    } 
    
                    if(window.location.hostname == "eu.unionbindingcompany.com") {
                      var symbol = theme.moneyFormat.replace('{{amount_with_comma_separator}}','');
                      var product_price_find = Shopify.formatMoney(product.price_min, '{{amount}}') + symbol
                    } else {
                      var product_price_find = Shopify.formatMoney(product.price_min)
                    }

                    $('.result-step').append(
                    `        
                    <div class="result-step__single">
                      <img class="img-choice" src="`+img_choice+`" alt="union finder">
                      <img src="`+product.featured_image+`" alt="union finder">
                      <div class="product-find-info">
                        <h4>`+product.title+` <br class="only-mob-991"/> <span class="product-find-info__size">Size `+boot_size__convert+`</span></h4>
                        <p class="product-find-info__price hide">`+product_price_find+`</p>
                        <div style="visibility:hidden" class="product-find-info__colortitle">`+n_colors+` `+text_color+`:</div>
                        <div style="visibility:hidden" class="product-find-info__colors">`+color_list_box+`</div>
                        <a class="union-cta-find" href="`+product.url+`?size_find=`+boot_size__convert+`" target="_blank">DISCOVER MORE</a>
                      </div>
                    </div>
                    `
                    );
                  });
    
                }
    
                var img_choice_1 = $(".result-step").attr("attr-choiche1")
                var img_choice_2 = $(".result-step").attr("attr-choiche2")
    
                // print_product("atlas", img_choice_1)
                // print_product("str", img_choice_2)
    
                print_product(scelta1, img_choice_1)

                setTimeout(function(){ 
                  print_product(scelta2, img_choice_2) 
                }, 250);
                
    
                // se volessi ciclare in futuro, usa:
                // prodotti_trovati.forEach((prodotto_singolo_trovato,pst) => {
                // })
    
              // }
    
            }
          });
    
        }
        else {
          $(".error-field-compile").addClass("show")
          setTimeout(function(){ 
            $(".error-field-compile").removeClass("show")
          }, 1500);
        }
      }
      else {
        $(".foot__after").removeClass("disabled")
      }
      // END STEP 4 - RISULTATI
    

      if (step_successivo) {
        if (new_step < 5) {
          $(".section-finder-box__step.selected").removeClass("selected")
          $(".foot__navigation i").removeClass("selected")
          $(".section-finder-box__step[attr-step='"+new_step+"']").addClass("selected")
          $(".foot__navigation i[attr-step='"+new_step+"']").addClass("selected")
        }
      } else {
        // console.log("step "+new_step+" non possibile")
      }

  })

  // Open finder parameter
  $( document ).ready(function() {
      let urlParams = new URLSearchParams(window.location.search)
      if( urlParams.has('finder') ) {
        $(".finder-open").trigger("click")
      }
  });

  // Bottone apertura finder
  $(".finder-open").on("click", function(){

    finder_opened = true

    $(".section-finder").removeClass("hide")
    $("body").removeClass("overflow-hidden")

    var cur_step = $(".section-finder-box__step.selected").attr("attr-step")

    if(cur_step == 1) {
      $(".foot__pre").addClass("disabled")
    } else {
      $(".foot__pre").removeClass("disabled")
    }

    // se sono dentro un prodotto, preseleziono il geneder di quel prodotto
    // if ($(".product-single__meta").length) {
    //   console.log("sono in un prodotto: "+finder_size_gender)
    //   $(".gender-step__single[attr-filter='"+finder_size_gender+"']").trigger("click")
    // }

  })

  // Bottone chiusura finder
  $(".head__close").on("click", function(){

    finder_opened = false

    $(".section-finder").addClass("hide")
    $("body").removeClass("overflow-hidden")
  })


  // Effetto select negli step 1 e 3 (effetto apertura stile menu a tendina)
  $(".select-style").on("click", function(e){

    e.stopPropagation();
    
    if ($(this).hasClass("open")) {
      $(this).removeClass("open")
      $(this).find("i.fa-chevron-down").removeClass("open")
      this.scrollTop = 0
    } else {
      $(this).addClass("open")
      $(this).find("i.fa-chevron-down").addClass("open")
    }
  })
  
  // Barra orizzontale
  $(".percent-bar-container").each(function(){
    var data_percent = $(this).find(".percent-bar-progression").attr("data-percent")
    $(this).find(".percent-bar-progression").css("width",data_percent+"%")

  })

};




// COMPARE *****************************************************************************************************************************************************************
var compare = function($) {

  // Compare - Simulate first click on load page 
  setTimeout(function(){ 
    let data_comp1 =  $(".section-compare .select-style[attr-col='1']").attr("data-comp")
    let data_comp2 =  $(".section-compare .select-style[attr-col='2']").attr("data-comp")
    let data_comp3 =  $(".section-compare .select-style[attr-col='3']").attr("data-comp")
    $(".section-compare .select-style[attr-col='1'] .option-style__single[attr-handle='"+data_comp1+"']").trigger("click")
    $(".section-compare .select-style[attr-col='2'] .option-style__single[attr-handle='"+data_comp2+"']").trigger("click")
    $(".section-compare .select-style[attr-col='3'] .option-style__single[attr-handle='"+data_comp3+"']").trigger("click")
    $(".section-compare .select-style .fa-chevron-down").removeClass("open")
    $(".section-compare .select-style").removeClass("open")
  }, 500);

  // Compare - Simulate first click on load page on compare system
  setTimeout(function(){ 
    $(".section-compare .select-style[attr-col='4'] .option-style__single:eq(1)").trigger("click")
    $(".section-compare .select-style[attr-col='5'] .option-style__single:eq(2)").trigger("click")
    $(".section-compare .select-style[attr-col='6'] .option-style__single:eq(3)").trigger("click")
    $(".section-compare .select-style .fa-chevron-down").removeClass("open")
    $(".section-compare .select-style").removeClass("open")
  }, 500);


  // Compare - select model
  $(".section-compare .select-style .option-style__single--selectable").on("click", function(){


    var column = $(this).parent().attr("attr-col")
    var column_element = $(".section-compare .col-comp-product[attr-col='"+column+"']")
    var handle = $(this).attr("attr-handle")
    var desc = $(this).attr("attr-desc")
    var listing_image = $(this).attr("attr-listing-image")

    var swiper_variant_images = []

    jQuery.getJSON(MR_LOCALE_ROOT+'/products/'+handle+'.js', function(product) {

      var colors = []
      var variant_images = []

      // Search in variants each image color "singular"
      product.variants.forEach((variant) => {

        var color_variant = variant.option1
        var image_variant = listing_image ? listing_image : variant.featured_image.src
        
        if ( !colors.includes(color_variant) ) {
          colors.push(color_variant)
          variant_images.push(image_variant)
        }

      })

      // Featured image
      column_element.find(".box__2 img.pacman-load").css("display","none")

      // Clean images before populate
      column_element.find(".box__2 .product-images").empty()


      //All product Images
      variant_images.forEach((variant_image, i) => {
        
        if ( i == 0 ) {
          column_element.find(".product-images").append("<img class='variant-image' attr-id='"+i+"' src='"+variant_image+"' alt='union image product'>")
        } else {
          column_element.find(".product-images").append("<img class='variant-image hide' attr-id='"+i+"' src='"+variant_image+"' alt='union image product'>")
        }

      })

      // Colors
      jQuery.ajax({
        url:"/pages/finder-list?view=compare-color.json", 
        success:function(products){
    
          var products_list = JSON.parse(products)

          for (var nome_attacco of Object.keys(products_list)) {

            if(handle == nome_attacco) {

              column_element.find(".round-color").remove()

              products_list[nome_attacco].forEach((color,ts) => { 

                if ( color == "Race Red" ) { var back_round_col = "#EE2737" }
                else if ( color == "Acid Green" ) { var back_round_col = "#dde61f" }
                else if ( color == "Aqua" ) { var back_round_col = "#73ddd3" }
                else if ( color == "Blue" ) { var back_round_col = "#a2c5d3" }
                else if ( color == "Bluebell" ) { var back_round_col = "#7c94de" }
                else if ( color == "Bone White" ) { var back_round_col = "#e3e1db" }
                else if ( color == "Bronze" ) { var back_round_col = "#8b7866" }
                else if ( color == "Bryan Iguchi" ) { var back_round_col = "#5781a6" }
                else if ( color == "Burgundy" ) { var back_round_col = "#a80034" }
                else if ( color == "Coral" ) { var back_round_col = "#ff5a5a" }
                else if ( color == "Green" ) { var back_round_col = "#4a848d" }
                else if ( color == "Gunmetal" ) { var back_round_col = "#596065" }
                else if ( color == "Hot Pink" ) { var back_round_col = "#e31d94" }
                else if ( color == "Hot Red" ) { var back_round_col = "#f8384b" }
                else if ( color == "Jib Gurl" ) { var back_round_col = "#231f20" }
                else if ( color == "Lavender" ) { var back_round_col = "#c5b1de" }
                else if ( color == "Light Blue" ) { var back_round_col = "#c7d2ec" }
                else if ( color == "Magenta" ) { var back_round_col = "#e00d5b" }
                else if ( color == "Metallic Black" ) { var back_round_col = "#231f20" }
                else if ( color == "Metallic Blue" ) { var back_round_col = "#185da4" }
                else if ( color == "Metallic Purple" ) { var back_round_col = "#645a9a" }
                else if ( color == "Metallic Red" ) { var back_round_col = "#b52d36" }
                else if ( color == "Metallic White" ) { var back_round_col = "#f0f0f0" }
                else if ( color == "Olive" ) { var back_round_col = "#606356" }
                else if ( color == "Mustard" ) { var back_round_col = "#d69b2d" }
                else if ( color == "Olive Green" ) { var back_round_col = "#888e64" }
                else if ( color == "Purple" ) { var back_round_col = "#5b4d63" }
                else if ( color == "Red" ) { var back_round_col = "#e80029" }
                else if ( color == "Sage Green" ) { var back_round_col = "#5d7261" }
                else if ( color == "Sand" ) { var back_round_col = "#907e6d" }
                else if ( color == "Silver" ) { var back_round_col = "#a8abad" }
                else if ( color == "Teal" ) { var back_round_col = "#006471" }
                else if ( color == "Tie Dye" ) { var back_round_col = "#a7c6cb" }
                else if ( color == "Violet" ) { var back_round_col = "#938695" }
                else if ( color == "Yellow" ) { var back_round_col = "#e3e28d" }
                else if ( color == "Black" ) { var back_round_col = "#000000" }
                else if ( color == "White" ) { var back_round_col = "#f2f2f2" }
                else if ( color == "Metallic Silver" ) { var back_round_col = "#aaadad" }
                else if ( color == "Asadachi" ) { var back_round_col = "#dcb9a0" }
                else if ( color == "Desert Camo" ) { var back_round_col = "#c8c1bb" }
                else if ( color == "Orange" ) { var back_round_col = "#ff5300" }
                else if ( color == "Cyan" ) { var back_round_col = "#2DCCD3" }
                else if ( color == "Lilac" ) { var back_round_col = "#d4c1d8" }
                else if ( color == "Seafoam Green" ) { var back_round_col = "#D6E6DF" }
                else if ( color == "Hunter Orange" ) { var back_round_col = "#F93822" }
                else if ( color == "Dark Green" ) { var back_round_col = "#59563E" }
                else if ( color == "Pink B4BC" ) { var back_round_col = "#DCA9BF" }
                else if ( color == "Royal Blue" ) { var back_round_col = "#003087" }
                else if ( color == "Tangerine" ) { var back_round_col = "#FAAA8D" }
                else if ( color == "Flame Orange" ) { var back_round_col = "#fc4c02" }
                else if ( color == "Brown" ) { var back_round_col = "#837773" }
                else if ( color == "Grey" ) { var back_round_col = "#d8e1e9" }
                else if ( color == "Pink" ) { var back_round_col = "#d0a0ba" }
                else if ( color == "Team" ) { var back_round_col = "#dadada" }
                else if ( color == "Blue Flames" ) { var back_round_col = "#2256b8" }
                else if ( color == "Tie Dye (B4BC)" ) { var back_round_col = "#d4c1d8" }
                else if ( color == "Chrome" ) { var back_round_col = "#808080" }
                else if ( color == "White/Orange" ) { var back_round_col = "#e56d03" }
                else if ( color == "Black 20-YR" ) { var back_round_col = "#2D2926" }
                else if ( color == "White 20-YR" ) { var back_round_col = "#F4F5F0" }
                else if ( color == "Army Green" ) { var back_round_col = "#59563e" }
                else if ( color == "Cyber Lime" ) { var back_round_col = "#b7bf10" }
                else if ( color == "Rose" ) { var back_round_col = "#dea39c" }
                else if ( color == "Bone" ) { var back_round_col = "#e4e2db" }
                else if ( color == "Camo" ) { var back_round_col = "#59563f" }
                else if ( color == "Sand Pink" ) { var back_round_col = "#dbcdd3" }
                else if ( color == "Ice Grey" ) { var back_round_col = "#d3cfd9" }
                else if ( color == "Sage" ) { var back_round_col = "#c6d6d0" }
                else if ( color == "Jess Kimura" ) { var back_round_col = "#59563e" }
                else if ( color == "Grey Violet" ) { var back_round_col = "#a37a8e" }
                else if ( color == "Midnight" ) { var back_round_col = "#2c2a29" }
                else if ( color == "Black / Orange" ) { var back_round_col = "#ff9800" }
                else if ( color == "Black / Black" ) { var back_round_col = "#2D2926" }
                else if ( color == "FC Black" ) { var back_round_col = "#000000" }
                else if ( color == "Pikachu" ) { var back_round_col = "#f6eb61" }
                else if ( color == "Khaki" ) { var back_round_col = "#C3B091" }
                else if ( color == "Heather Grey" ) { var back_round_col = "#dadada" }
                else if ( color == "Zinc White" ) { var back_round_col = "#F9F9F9" }
                else if ( color == "Kazu Kokubo" ) { var back_round_col = "#b62e36" }
                else if ( color == "Tye Dye" ) { var back_round_col = "#9fc1ea" }
                else if ( color == "Stone" ) { var back_round_col = "#cccfce" }
                else if ( color == "Bianco" ) { var back_round_col = "#f2f2f2" }
                else if ( color == "Glacier Shadow" ) { var back_round_col = "#dcebe5" }
                else if ( color == "Neon Yellow" ) { var back_round_col = "#dddd2c" }
                else if ( color == "Blue-Grey" ) { var back_round_col = "#7697ac" }
                else if ( color == "Cool Grey" ) { var back_round_col = "#d6d7d5" }
                else if ( color == "Kevin Backstrom" ) { var back_round_col = "#e4e0db" }
                else if ( color == "Tactical Green" ) { var back_round_col = "#62665c" }
                else if ( color == "Cosmo" ) { var back_round_col = "#142c66" }
                else if ( color == "Light Grey" ) { var back_round_col = "#d8e1e9" }
                else if ( color == "Ice Blue" ) { var back_round_col = "#a7c6cb" }
                else if ( color == "Dark Blue" ) { var back_round_col = "#4c748c" }
                else if ( color == "B4BC" ) { var back_round_col = "#bfa4b9" }
                else if ( color == "Spring Break" ) { var back_round_col = "#fd9cb1" }
                else if ( color == "Tan" ) { var back_round_col = "#494835" }
                else if ( color == "Mauve" ) { var back_round_col = "#868098" }
                else { var back_round_col = "#000" }
  

                // Immagine variante-colore (stesso indice usato dal click che mostra .variant-image)
                var swatch_img = variant_images[ts]
                var swatch_img_tag = swatch_img
                  ? `<img class="round-color__img" src="`+ mrResizeImg(swatch_img, 200) +`" alt="`+color+`" loading="lazy">`
                  : ``
                var swatch_img_class = swatch_img ? ` round-color--img` : ``

                column_element.find(".color-variants").append(
                  `
                  <span class="round-color`+swatch_img_class+`"
                      attr-value="`+color+`"
                      attr-id="`+ts+`"
                      attr-col-id="`+column+`"
                      style="background-color:`+back_round_col+`;" >
                    `+swatch_img_tag+`
                    <i class="fas fa-check hide"></i>
                  </span>
                  `
                );
              })
            }
          }
        }
      })

      // console.log(Shopify.formatMoney())
      // console.log(theme.moneyFormat)
      // Price
      if ((window.location.hostname == "eu.unionbindingcompany.com") || (window.location.hostname == "jp.unionbindingcompany.com")) {
        var symbol = theme.moneyFormat.replace('{{ amount_with_comma_separator }}','')
        symbol = symbol.replace('{{amount_no_decimals}}','')
        symbol = symbol.replace('{{amount_with_comma_separator}}','')
        symbol = symbol.replace('.00','')
        column_element.find(".current-product__price").html(Shopify.formatMoney(product.price, '{{amount}}') + symbol)
      } else {
        column_element.find(".current-product__price").html(Shopify.formatMoney(product.price))
      }

      // Button link
      column_element.find(".buy-now-button").attr("href",product.url)
      column_element.find(".buy-now-button .visually-hidden").text(" " + product.title)

      // Description
      // column_element.find(".box__3").text(product.description.replace(/<[^>]*>?/gm, ''))
      column_element.find(".box__3").text(desc.replace(/<[^>]*>?/gm, ''));

      // Riding Style
      jQuery.ajax({
        url:"/pages/finder-list?view=compare-riding.json", 
        success:function(products){
    
          var products_list = JSON.parse(products)

          for (var nome_attacco of Object.keys(products_list)) {

            if(handle == nome_attacco) {

              var freestyle = Number(products_list[nome_attacco][0])
              var all_mountain = Number(products_list[nome_attacco][1])
              var freeride = Number(products_list[nome_attacco][2])
              
              var flex = Number(products_list[nome_attacco][3])
              // var flex = (Number(products_list[nome_attacco][3]) + Number(products_list[nome_attacco][4]))/2

              column_element.find(".riding-style.freestyle .percent-bar-progression").attr("data-percent",freestyle).css("width",freestyle+"%")

              column_element.find(".riding-style.all-mountain .percent-bar-progression").attr("data-percent",all_mountain).css("width",all_mountain+"%")

              column_element.find(".riding-style.freeride .percent-bar-progression").attr("data-percent",freeride).css("width",freeride+"%")

              column_element.find(".binding-flex .percent-bar-progression").attr("data-percent",flex).css("width",flex+"%")


            }
          }
        }
      })

      // Riding Style
      jQuery.ajax({
        url:"/pages/finder-list?view=compare-others.json", 
        success:function(products){
    
          var products_list = JSON.parse(products)

          for (var nome_attacco of Object.keys(products_list)) {

            if (handle == nome_attacco) {

              var disk = products_list[nome_attacco][0]
              var features_details = "" //adjust later
              var weight = products_list[nome_attacco][2]              
              var compatibility = products_list[nome_attacco][3]

              if (products_list[nome_attacco][1][0]) {
                features_details = products_list[nome_attacco][1][0]
              } else {
                features_details = products_list[nome_attacco][1]
              }
              
              column_element.find(".disk-types").html("<strong>Disk Type:</strong><br/>"+disk+"<br/><strong>Compatibility:</strong> "+compatibility)

              $.each(features_details, function(index, element) {
                
                var title_row = index.toString().toLowerCase().replace(" ", "_")

                // console.log(element)
                if (element["title"] == "") {
                  var title_element = "-"
                } else {
                  var title_element = element["title"]
                }

                column_element.find("."+title_row).text(title_element)

                if (element["new"] == "yes") {
                  // var title_element_new = '<span class="data-new">NEW</span>'
                  column_element.find("."+title_row).prepend('<span class="data-new">NEW</span>')
                } else {
                  // var title_element_new = ''
                }

              });

              column_element.find(".content-weight").text(weight+"KG")



              // column_element.find(".baseplate").text(baseplate)
              // column_element.find(".bushing").text(bushing)
              // column_element.find(".heelcup").text(heelcup)
              // column_element.find(".highback").text(highback)
              // column_element.find(".ankle_strap").text(ankle_strap)
              // column_element.find(".toe_strap").text(toe_strap)
              // column_element.find(".ratchets").text(ratchets)
              // column_element.find(".flad").text(flad)
              // column_element.find(".hardware").text(hardware)


            }
          }
        }
      })

      // Title
      column_element.find(".last-title").text(product.title)

    } );

    $(".select-style[attr-col='"+column+"'] .option-style__single").addClass("option-style__single--selectable")
    $(this).removeClass("option-style__single--selectable")
    $(this).prependTo(".select-style[attr-col='"+column+"']")

    // setTimeout(function(){ 
    //   $(".model-selection .select-style .fa-chevron-down.open").removeClass("open")
    //   $(".model-selection .select-style.open").removeClass("open")
    // }, 250);

    // On variant color click, show corrisponding color image
    $(".col-comp-product").on("click", ".color-variants .round-color", function(){
  
      // console.log("clickkkk")
      var attr_color_id = $(this).attr("attr-id")
      var attr_color_column = $(this).attr("attr-col-id")
      $(".col-comp-product[attr-col='"+attr_color_column+"']").find(".product-images .variant-image").addClass("hide")
      $(".col-comp-product[attr-col='"+attr_color_column+"']").find(".product-images .variant-image[attr-id='"+attr_color_id+"']").removeClass("hide")
    })

  })
  

}


// HEADER *****************************************************************************************************************************************************************
var header = function($){
  $(".serach-icon-mob").on("click", function() {
    $("#SearchDrawer").addClass("show")
  })
  $(".plp-search-close").on("click", function() {
    $("#SearchDrawer").removeClass("show")
  })

  $(".country-site-selector").on("click", function(){
    if ($(this).hasClass("opened")) {
      $(this).removeClass("opened")
    } else {
      $(this).addClass("opened")
    }
  })

  document.addEventListener('click', e => {
    if (document.querySelector(".country-site-selector")) {
      if ((!document.querySelector(".country-site-selector").contains(e.target)) && (!document.querySelector(".country-site-selector__other").contains(e.target)) ) {
        document.querySelector(".country-site-selector").classList.remove("opened")
      }
    }
  });
  
  $(".site-nav--has-dropdown").on({
    mouseenter: function () {
      $(this).addClass("site-nav--active-dropdown")
      $(this).find("button.site-nav__link").attr("aria-expanded","true")
      // $(this).find(".site-nav__dropdown")
    },
    mouseleave: function () {
      $(this).removeClass("site-nav--active-dropdown")
      $(this).find("button.site-nav__link").attr("aria-expanded","false")
      // $(this).find(".site-nav__dropdown")
    }
  });


    var lastScrollTop = 0;
    $(window).on("scroll", function(event){
      var st = $(this).scrollTop();
      if (st > lastScrollTop){
          // downscroll code
          $("#shopify-section-header").removeClass("is-sticky")
          $("main.main-content").css("margin-top","0")
      } else {
        if ( window.scrollY > 85 ) {
          $("#shopify-section-header").addClass("is-sticky")
          $("main.main-content").css("margin-top","110px")
        } else {
          $("#shopify-section-header").removeClass("is-sticky")
          $("main.main-content").css("margin-top","0")

        }
      }
      lastScrollTop = st;

      // Add to Cart Sticky
      if (window.innerWidth < 769 ) { 
        var add_cart_button = $(".product-form__controls-group.product-form__controls-group--submit")
        if (add_cart_button != undefined) {

          if (add_cart_button.offset().top) {

            var bottom_of_element = add_cart_button.offset().top + add_cart_button.outerHeight();
        
            if (st < bottom_of_element) {
              $(".buy-now-scroll-mob").removeClass("show")
            } else {
              $(".buy-now-scroll-mob").addClass("show")
            }
          }
        }
      };
      $(".buy-now-scroll-mob").on("click", function(event){
        event.stopImmediatePropagation()
        $('html,body').animate({
          scrollTop: $(".product-single__meta").offset().top - 80
      }, 1000);
      })
      
    });
  
}

// FOOTER *****************************************************************************************************************************************************************
var footer = function($){

//   document.querySelector('.country-site-selector__select').addEventListener("change", function(country_option){
//     if (country_option.target.value == "EUROPE") {
//       window.location.replace("https://eu.unionbindingcompany.com/");
//     }
//     if (country_option.target.value == "NORTH AMERICA") {
//         window.location.replace("https://unionbindingcompany.com/");
//       }
//       if (country_option.target.value == "JAPAN") {
//         window.location.replace("https://jp.unionbindingcompany.com/");
//       }
//   });

}

// HOME *****************************************************************************************************************************************************************
var home = function($){

}

// PDP *****************************************************************************************************************************************************************
var pdp = function($){

  if ($(".template-product").length) {
    
    if ($(".template-product").hasClass("template--product--bindings-falcor-cap-lamb") || $(".template-product").hasClass("template--product--bindings-falcor-cap-lamb-global")) {

      // Swiper PDP Images
      if ($(".product_bundle__1 .swiper-pdp")) {
        var swiper_pdp_1 = new Swiper(".product_bundle__1 .swiper-pdp", {
          slidesPerView: 1,
          navigation: {
            nextEl: ".product_bundle__1 .swiper-button-next",
            prevEl: ".product_bundle__1 .swiper-button-prev",
          },
          pagination: {
            el: ".product_bundle__1 .swiper-pagination",
          },
          // observer: true,
          // observeParents: true
        });
      }

      if ($(".product_bundle__2 .swiper-pdp")) {
        var swiper_pdp_2 = new Swiper(".product_bundle__2 .swiper-pdp", {
          slidesPerView: 1,
          navigation: {
            nextEl: ".product_bundle__2 .swiper-button-next",
            prevEl: ".product_bundle__2 .swiper-button-prev",
          },
          pagination: {
            el: ".product_bundle__2 .swiper-pagination",
          },
          // observer: true,
          // observeParents: true
        });
      }


    } else {
      console.log("slider altro")
      // Swiper PDP Images
      var swiper_pdp = new Swiper(".swiper-pdp", {
        slidesPerView: 1,
        pagination: {
          el: ".pdp-slider-images .swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".pdp-slider-images .swiper-button-next",
          prevEl: ".pdp-slider-images .swiper-button-prev",
        },
        // observer: true,
        // observeParents: true
      });
    }



    var variation_selection = {
      "color": false,
      "size": false
    }

    if ( $(".variant-size").length == 0 ) {
      variation_selection.size = true
    }

    if ( $(".variant-color").length == 0 ) {
      variation_selection.color = true
    }

    var variation_selection__bundle = {
      "prod1": {
        "color": false,
        "size": false
      },
      "prod2": {
        "color": false,
        "size": false
      }
    }

    if ( $(".product_bundle__1 .variant-size").length == 0 ) {
      variation_selection__bundle.prod1.size = true
    }

    if ( $(".product_bundle__1 .variant-color").length == 0 ) {
      variation_selection__bundle.prod1.color = true
    }

    if ( $(".product_bundle__2 .variant-size").length == 0 ) {
      variation_selection__bundle.prod2.size = true
    }

    if ( $(".product_bundle__2 .variant-color").length == 0 ) {
      variation_selection__bundle.prod2.color = true
    }

    function check_if_variations_are_selected() {

      // se colore o size non sono selezionati cta disattivata
      if ( ( variation_selection.color == false ) || (variation_selection.size == false ) ) {

        $("button.product-form__cart-submit").addClass("btn-disabled")
        $("button.product-form__cart-submit").text(wcStr("addToCart","Add to cart"))

        setTimeout(function(){ 
          if ( $(".variations-sizes .square-size").not(".unavailable").length === $(".variations-sizes .square-size.soldout").length ) {
            $("button.product-form__cart-submit").addClass("btn-disabled--soldout")
            if ( $("button.product-form__cart-submit").attr("attr-coming-soon") == "true" ) {
              $("button.product-form__cart-submit").text(wcStr("comingSoon","Coming Soon"))
            } else {
              $("button.product-form__cart-submit").text(String(wcStr("soldOut","SOLD OUT")).toUpperCase())
            }
          }
        }, 250);
        
      } else {
        $("button.product-form__cart-submit").removeClass("btn-disabled")
      }
      
      if (!$(".template-product").hasClass("template--product--gift-card")) {
        if ( ( variation_selection.color == true ) && (variation_selection.size == true ) ) {
          setTimeout(function(){ 
            if ( !$(".product-single__store-availability-container div").hasClass("store-availability-container")) {
              console.log("color && size true")
              if ( $("button.product-form__cart-submit").attr("attr-coming-soon") == "true" ) {
                $("button.product-form__cart-submit").text(wcStr("comingSoon","Coming Soon"))
              } else {
                $("button.product-form__cart-submit").text(String(wcStr("soldOut","SOLD OUT")).toUpperCase())
              }
            } else {
              $("button.product-form__cart-submit").text(wcStr("addToCart","Add to cart"))
            }
          }, 250);
  
        }
      }

      $(".error-field-compile-product").removeClass("show")
      $(".border-error").removeClass("show")

    }

    function check_if_variations_are_selected_in_bundle() {

      $("button.product-form__cart-submit").addClass("btn-disabled")
      $("button.product-form__cart-submit").text(wcStr("addToCart","Add to cart"))

      if ( ( variation_selection__bundle.prod1.color == false ) || (variation_selection__bundle.prod1.size == false ) ) {
        if ( $(".product_bundle__1 .variations-sizes .square-size").not(".unavailable").length === $(".product_bundle__1 .variations-sizes .square-size.soldout").length ) {
          $(".product_bundle__1 button.product-form__cart-submit").addClass("btn-disabled--soldout")
          if ( $(".product_bundle__1 button.product-form__cart-submit").attr("attr-coming-soon") == "true" ) {
            $(".product_bundle__1 button.product-form__cart-submit").text(wcStr("comingSoon","Coming Soon"))
          } else {
            $(".product_bundle__1 button.product-form__cart-submit").text(String(wcStr("soldOut","SOLD OUT")).toUpperCase())
          }
        }
      } else {
        $(".product_bundle__1 button.product-form__cart-submit").removeClass("btn-disabled")
      }
      
      $(".product_bundle__1 .error-field-compile-product").removeClass("show")
      $(".product_bundle__1 .border-error").removeClass("show")

      if ( ( variation_selection__bundle.prod2.color == false ) || (variation_selection__bundle.prod2.size == false ) ) {
        if ( $(".product_bundle__2 .variations-sizes .square-size").not(".unavailable").length === $(".product_bundle__2 .variations-sizes .square-size.soldout").length ) {
          $(".product_bundle__2 button.product-form__cart-submit").addClass("btn-disabled--soldout")
          if ( $(".product_bundle__2 button.product-form__cart-submit").attr("attr-coming-soon") == "true" ) {
            $(".product_bundle__2 button.product-form__cart-submit").text(wcStr("comingSoon","Coming Soon"))
          } else {
            $(".product_bundle__2 button.product-form__cart-submit").text("SOLD OUT ONLINE")
          }
        }
      } else { 
        $(".product_bundle__2 button.product-form__cart-submit").removeClass("btn-disabled")
      }
      
      $(".product_bundle__2 .error-field-compile-product").removeClass("show")
      $(".product_bundle__2 .border-error").removeClass("show")

    }

    if ($(".product_bundle__1").length) {
      setTimeout(function(){ 
        check_if_variations_are_selected_in_bundle()
      }, 250);
    } else {
      check_if_variations_are_selected()
    }

    $(".product-form__controls-group.product-form__controls-group--submit").on("click", function(){
      
      if ( $(".product-form__cart-submit").hasClass("btn-disabled") ) {
        $(".error-field-compile-product").addClass("show")
        $(".border-error").addClass("show")
      } 

    })

    $(".scroll-down-cta").click(function() {
      $([document.documentElement, document.body]).animate({
          scrollTop: $("#shopify-section-product-informations").offset().top - 25
      }, 1000);
    });

  }



  // PDP Read size information if send from Finder link
  $( document ).ready(function() {
    if ($(".template-product").length !== "") {
      let urlParams = new URLSearchParams(window.location.search)
      if( urlParams.has('size_find') ) {
        let param_size = urlParams.get('size_find')
        $(".square-size[attr-value='"+param_size+"']").trigger("click")
      }
      if( urlParams.has('variant') ) {
        let param_variant = urlParams.get('variant')

        let vatiations_colors = document.querySelectorAll(".product-single__meta .round-color")

        vatiations_colors.forEach(vatiations_color => {
          let attr_color_variant_id = vatiations_color.getAttribute("attr-variant-id")
          // console.log(attr_color_variant_id + " -- " + param_variant)
          if (attr_color_variant_id == param_variant) {
            vatiations_color.click()
          }
        });
        document.querySelector('.product-template__container').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        
        // $(".product-single__meta .variations-colors .round-color[attr-variant-id='"+param_variant+"']").trigger("click")
      }
    }
  });


  // PDP Open bar
  $(".details-box__content h5").on("click", function(){

    if ( $(this).find("i.fa-chevron-down").hasClass("open") ) {
      $(this).find("i.fa-chevron-down").removeClass("open")
      $(this).parent().addClass("closed")
      
    } else {
      $(this).find("i.fa-chevron-down").addClass("open")
      $(this).parent().removeClass("closed")
    }
    
  })

  var color_change = document.getElementById('SingleOptionSelector-0');
  var size_change = document.getElementById('SingleOptionSelector-0');

  var size_changeB1 = document.getElementById('SingleOptionSelector-0-b1');
  var size_changeB2 = document.getElementById('SingleOptionSelector-0-b2');

  var event_color_change = new Event('change');
  var event_size_change = new Event('change');

  // PDP Select Variation Colors
  $(".product-form__controls-group .round-color").on("click", function(){

    var is_checked = false
    // il controllo lo fa sullo stato del pre-click quindi è corretto così
    if ($(this).find("i.fas").hasClass("hide")) {
      is_checked = true
    }

    // reset slider images
    $(".pdp-slider-images .swiper-slide").each(function(index){
      $(this).removeClass("hide")
    })

    $(".product-form-product-template-bindings").css("opacity","0")

    var val_select_color = $(this).attr("attr-value")
    var val_select_color__img_slider = $(this).attr("attr-img_slider").replace(/\.(jpe?g|png|webp)$/i,'');
    var attr_num_of_img = Number($(this).attr("attr-num-of-img"))

    var num_index_img_find = "0"
    var index_first_image = 0
    var index_last_image = 0

    // check slide to show
    $(".pdp-slider-images .swiper-slide").each(function(index){
      var attr_img_url = $(this).attr("attr-img-url")
      if (~attr_img_url.indexOf(val_select_color__img_slider)) {
        num_index_img_find = $(this).attr("attr-num")
        index_first_image = index
        index_last_image = index_first_image + attr_num_of_img - 1
        return false;
      } 
    })
    swiper_pdp.update()

    // if bindings go hide "no this color" slides
    if ($("body").hasClass("template-product")) {
      if (is_checked) {
        $(".pdp-slider-images .swiper-slide").each(function(index_check){
          if ( (index_check < index_first_image) || (index_check > index_last_image) ) {
            $(this).addClass("hide")
          }
        })
        swiper_pdp.slideTo(0)
        swiper_pdp.update()
      } else {
        swiper_pdp.slideTo(0)
      }
    } else {
      if (is_checked) {
        $(".pdp-slider-images .swiper-slide").each(function(index_check){
          if ( (index_check < index_first_image) || (index_check > index_last_image) ) {
            $(this).addClass("hide")
          }
        })
        swiper_pdp.slideTo(0)
        swiper_pdp.update()
      } else {
        swiper_pdp.slideTo(0)
      }
    }

    if($(this).find("i").hasClass("hide")) {
      $(".round-color").find("i").addClass("hide")
      $(this).find("i").removeClass("hide")
      $(".variant-color .single-option-selector").val(val_select_color).change();

      color_change.dispatchEvent(event_color_change);
      // console.log("passo1")
      variation_selection.color = true // Need to check if variation color is checked do enable add to cart button
      if ($(".product_bundle__1").length) {
        setTimeout(function(){ 
          check_if_variations_are_selected_in_bundle()
        }, 250);
      } else {
        check_if_variations_are_selected()
      }  

    } else {
      $(this).find("i").addClass("hide")
      $(".variant-color .single-option-selector").val("")

      variation_selection.color = false // Need to check if variation color is checked do enable add to cart button
      if ($(".product_bundle__1").length) {
        setTimeout(function(){ 
          check_if_variations_are_selected_in_bundle()
        }, 250);
      } else {
        check_if_variations_are_selected()
      }

    }

    
    var product_handle = $(".product-single__title").attr("attr-handle")
    
    jQuery.getJSON(MR_LOCALE_ROOT+'/products/'+product_handle+'.js', function(product_sel) {
      
      $(".variations-sizes .square-size").removeClass("unavailable")
      $(".variations-sizes .square-size").removeClass("soldout")
      var array_size_available = []
      var array_size_available_inventory_quantity = []
      // mappa taglia(option2) -> variante, SOLO per il colore selezionato
      var size_variant_map = {}

      product_sel.variants.forEach((variant) => {

        if ( variant.option1 == val_select_color ) {
          array_size_available.push(variant.option2)
          array_size_available_inventory_quantity.push(variant)
          // se piu' varianti condividono la stessa taglia, preferisci quella disponibile
          if ( !size_variant_map[variant.option2] || variant.available ) {
            size_variant_map[variant.option2] = variant
          }
        }

      })

      // Per OGNI square-size renderizzata: verifica per attr-value (generico, funziona
      // con qualsiasi valore: S, M, L, M/L, XL, OSFM, 154, ...):
      //  - il colore selezionato NON ha quella taglia  -> "unavailable"
      //  - la taglia esiste ma e' esaurita             -> "soldout"
      //  - altrimenti disponibile                      -> nessuna delle due
      $(".variations-sizes .square-size").each(function(){
        var size_val = $(this).attr("attr-value")
        var variant_for_size = size_variant_map[size_val]
        if ( !variant_for_size ) {
          $(this).addClass("unavailable")
          $(this).removeClass("soldout")
        } else if ( variant_for_size.available == false ) {
          $(this).addClass("soldout")
        } else {
          $(this).removeClass("soldout")
        }
      })

      $(".product-form.product-form-product-template-bindings").css("opacity","1")

      if ($(".product_bundle__1").length) {
        setTimeout(function(){ 
          check_if_variations_are_selected_in_bundle()
        }, 250);
      } else {
        check_if_variations_are_selected()
      }
    })

    if ($(".product_bundle__1").length) {
      setTimeout(function(){ 
        check_if_variations_are_selected_in_bundle()
      }, 250);
    } else {
      check_if_variations_are_selected()
    }

    if( $(".color-name-selected").length ) {
      let ltd_text = ""
      if (val_select_color == "Chrome") {
        ltd_text = "LIMITED EDITION!"
      }
      $(".color-name-selected").text(">> "+val_select_color+" "+ltd_text)
    }

    setTimeout(function(){

      var num_of_sizes = $( ".variations-sizes .square-size" ).not( ".unavailable" ).length

      if ( num_of_sizes == 1) {
        $(".product-single__meta .variations-sizes .square-size").trigger("click")
      }

    }, 300);


  })

  // PDP Select Variation Sizes
  $(".product-form__controls-group .variations-sizes .square-size").on("click", function(){

    var val_select_size = $(this).attr("attr-value")

    if($(this).hasClass("selected") == false) {
      $(".square-size").removeClass("selected")
      $(this).addClass("selected")
      $(".variant-size .single-option-selector").val(val_select_size).change();

      if (size_change) { size_change.dispatchEvent(event_size_change); }
      if (size_changeB1) { size_changeB1.dispatchEvent(event_size_change); }
      if (size_changeB2) { size_changeB2.dispatchEvent(event_size_change); }

      variation_selection.size = true // Need to check if variation size is checked do enable add to cart button
      check_if_variations_are_selected()

    } else {
      $(this).removeClass("selected")
      $(".variant-size .single-option-selector").val("")

      variation_selection.size = false // Need to check if variation size is checked do enable add to cart button
      check_if_variations_are_selected()

    }
    
  })

  // PDP Slide Img product >> Next
  $(".grid__item.product-single__media-group .arrow-right").on("click", function(){

    var num_images = $('.product-single__media-wrapper.js').length

    var actual_position = $(".product-single__media-wrapper.js:not(.hide)").attr("attr-numeration")
    var dot_num = parseInt(actual_position, 10) + 1;

    // console.log("Num di immagini: "+num_images)
    // console.log("Img attuale: "+actual_position)
    if ( actual_position < num_images ) {
      $(".product-single__media-wrapper.js:not(.hide)").addClass("toremove")
      $(".product-single__media-wrapper.js.toremove").next().removeClass("hide")
      $(".product-single__media-wrapper.js.toremove").addClass("hide").removeClass("toremove")

      $(".single-dot-nav").removeClass("active")
      $(".single-dot-nav[attr-img='"+dot_num+"']").addClass("active")
    }



  })
  
  // PDP Slide Img product >> Prev
  $(".grid__item.product-single__media-group .arrow-left").on("click", function(){

    var actual_position = $(".product-single__media-wrapper.js:not(.hide)").attr("attr-numeration")
    var dot_num = parseInt(actual_position, 10) - 1;

    // console.log("Img attuale: "+actual_position)
    if ( actual_position > 1 ) {

      $(".product-single__media-wrapper.js:not(.hide)").addClass("toremove")
      $(".product-single__media-wrapper.js.toremove").prev().removeClass("hide")
      $(".product-single__media-wrapper.js.toremove").addClass("hide").removeClass("toremove")

      $(".single-dot-nav").removeClass("active")
      $(".single-dot-nav[attr-img='"+dot_num+"']").addClass("active")
    }

  })

  if (window.innerWidth > 991 ) { 
    // PDP Slide Img Click
    $('.pdp-slider-images .swiper-slide').on("click", function(){

      var slider_pdp_num = $(this).attr("attr-num")
      var sliders_pdp = $(this).closest(".swiper-container.swiper-pdp .swiper-wrapper").prop("innerHTML")
      let swiper_bundle = $(this).attr("attr-bundle")

      $('body.template-product').append(
        `
          <div class="modal-big-vault">
            <img class="close-vault" src="https://cdn.shopify.com/s/files/1/0296/3764/0285/files/x-black.png?v=1628003948" alt="close vault">
              <div class="modal-pdp-images">
                <div class="swiper-container swiper-container--modal-pdp">
                  <div class="swiper-wrapper">
                    `+sliders_pdp+`
                  </div>

                  </div>
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>

                <div class="swiper-pagination"></div>
              </div>
          </div>
        `
      ); 

      // Swiper PDP Images
      var modal__swiper_pdp = new Swiper(".swiper-container--modal-pdp", {
        slidesPerView: 1,
        pagination: {
          el: ".modal-big-vault .swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".modal-big-vault .swiper-button-next",
          prevEl: ".modal-big-vault .swiper-button-prev",
        },
        // observer: true,
        // observeParents: true
      });

      if (swiper_bundle) {
        if (swiper_bundle == "product_bundle__1") {
          modal__swiper_pdp.slideTo(swiper_pdp_1.activeIndex)
        }
        if (swiper_bundle == "product_bundle__2") {
          modal__swiper_pdp.slideTo(swiper_pdp_2.activeIndex)
        }
      } else {
        modal__swiper_pdp.slideTo(swiper_pdp.activeIndex)
      }

      // PDP Remove Image zoom 
      $(".close-vault").on("click", function(){
        $(".modal-big-vault").remove()
      })

      })  
  }

  // PDP Size Chart
  // Sposta la modale in fondo al <body>: il transform di .page-container (drawer)
  // fa da containing block al position:fixed e sfaserebbe il centraggio a schermo.
  $(".modal-size-chart").appendTo("body");
  $(".size-chart").on("click", function() {
    $(".modal-size-chart").addClass("show")
  })
  // Chiudi solo cliccando sul backdrop, non sul contenuto della card (bottoni cm/inch, ecc.)
  $(".modal-size-chart").on("click", function(e) {
    if (e.target === this) $(this).removeClass("show")
  })
  $(".modal-size-chart__close").on("click", function(e) {
    e.stopPropagation()
    $(this).closest(".modal-size-chart").removeClass("show")
  })

  // PDP Finder Size - 1
  if($(".find-size").length) {

    // per il "find my size" della zona scheda prodotto
    window.finder_size_gender = $(".product-single__meta__find-size .find-size__group").attr("attr-find")

    var finder_size_type = ""
    var finder_size_num = ""
      var is_unisex = $(".product-single__meta__find-size").hasClass("find-size--unisex")
      // check gender e nascondo i size num non corrispondenti al gender
      // (per gli unisex NON rimuovo nulla: il gender è dinamico e si filtra al volo)
      $(".product-single__meta .tag_find_size__num").each(function(){
        if ( !is_unisex && $(this).attr("attr-gender") !== finder_size_gender) {
          $(this).remove()
        }
      })

      // PDP unisex: alla scelta del gender aggiorna il gender globale e ricalcola la numerazione
      $(".tag_find_size__gen").on("click", function(){
        var sel_gender = $(this).text().trim()
        sel_gender = sel_gender.charAt(0).toUpperCase() + sel_gender.slice(1).toLowerCase()
        window.finder_size_gender = sel_gender

        var $fs = $(".product-single__meta__find-size")
        // il tipo "US" dipende dal gender (us-men / us-women)
        $fs.find(".tag_find_size__type--us").attr("attr-find", "us-" + sel_gender.toLowerCase())

        // memorizzo il numero scelto prima, poi resetto numero e risultato
        var prev_num = finder_size_num
        finder_size_num = ""
        $fs.find(".tag_find_size__num").removeClass("selected")
        $fs.find(".find-size__num .select-style__single--select").prependTo($fs.find(".find-size__num"))
        $fs.find(".square-size").addClass("hide")
        $fs.find(".square-size--empty").removeClass("hide")

        // se un "type" è già selezionato, ri-filtro le num per il nuovo gender (US: rileggo l'attr-find aggiornato)
        var $selType = $fs.find(".tag_find_size__type.selected")
        if ($selType.length) {
          finder_size_type = $selType.attr("attr-find")
          $fs.find(".tag_find_size__num").each(function(){
            var num_gender = $(this).attr("attr-gender")
            var num_type = $(this).attr("attr-type")
            if (num_type === finder_size_type && num_gender === sel_gender) {
              $(this).removeClass("hide")
            } else {
              $(this).addClass("hide")
            }
          })
          $fs.find(".find-size__num").addClass("active")

          // se lo stesso intervallo esiste anche per il nuovo gender, lo ri-seleziono e ricalcolo
          var $match = $fs.find(".tag_find_size__num").filter(function(){
            return $(this).attr("attr-type") === finder_size_type
                && $(this).attr("attr-gender") === sel_gender
                && $(this).attr("attr-find") === prev_num
          })
          if (prev_num !== "" && $match.length) {
            finder_size_num = prev_num
            $match.addClass("selected")
            $match.prependTo($match.parent())
            calculate_size($match.attr("attr-where-is"))
          }
        }
      })


    function calculate_size(where_is_finder) {
  
      var combination_to_search = finder_size_gender+"$"+finder_size_type+"$"+finder_size_num
  
      // find size on list of all combinations
      jQuery.ajax({
        url:"/pages/finder-list?view=find-size.json", 
        success:function(sizes_list){
    
          var sizes_list_parse = JSON.parse(sizes_list)
  
          for (var size_single of Object.keys(sizes_list_parse)) {
  
            sizes_list_parse[size_single].forEach((combination_single,cs) => { 
              
              if(combination_to_search == combination_single) {
                // console.log("trovatA: "+size_single+" qui: "+where_is_finder)
                var result_size = size_single
                // Eccezione unisex: per il tipo "US Women" la taglia scala di uno (Large->Medium, Medium->Small)
                if ($(".find-size."+where_is_finder).hasClass("find-size--unisex") && finder_size_type === "us-women") {
                  if (size_single === "Large") { result_size = "Medium" }
                  else if (size_single === "Medium") { result_size = "Small" }
                }
                $(".find-size."+where_is_finder+" .square-size").addClass("hide")
                $(".find-size."+where_is_finder+" .square-size[attr-value='"+result_size+"']").removeClass("hide")
                $(".find-size."+where_is_finder+" .square-size[attr-value='"+result_size+"']").trigger("click")
              }
            })
          }
  
          
        }
      })
  
    }
  
    
    $(".tag_find_size__type").on("click", function(e){

      let gender_tag_pdp = $(".find-size__group").attr("attr-find")

      console.log("GENDER PDP SIZE: " + gender_tag_pdp)
  
      var where_is_finder = $(this).attr("attr-where-is")
      e.preventDefault();

      var size_type_parent = $(this).parent()

      finder_size_type = $(this).attr("attr-find")
      boot_size__type = finder_size_type // per variabile globale ad uso finder

      $(".tag_find_size__type").removeClass("selected")
      $(this).addClass("selected")
      $(this).prependTo(size_type_parent)
      
      $(".tag_find_size__num").each(function(){

        var tag_num__gender = $(this).attr("attr-gender")
        var tag_num__type = $(this).attr("attr-type")

        if ( tag_num__type !== finder_size_type ) {
          $(this).addClass("hide")
        } else {
          $(this).removeClass("hide")
          
          if(finder_opened) {
            console.log("finder_opened")
            finder_size_gender = gender_tag_pdp
            if(tag_num__gender !== gender_tag_pdp) {
              $(this).addClass("hide")
            }
          } else {
            finder_size_gender = $(".product-single__meta__find-size .find-size__group").attr("attr-find")
            console.log("finder_size_gender: "+finder_size_gender)
            // unisex: filtro le taglie anche per gender (le altre non sono rimosse a load)
            if (is_unisex && tag_num__gender !== finder_size_gender) {
              $(this).addClass("hide")
            }
          }
        }
      })

      $(".find-size__num").addClass("active")
      
      if ((finder_size_type !== "") && (finder_size_gender !== "") && (finder_size_num !== "")) {
        if(finder_opened) {
          finder_size_gender = gender_tag
        } else {
          finder_size_gender = $(".product-single__meta__find-size .find-size__group").attr("attr-find")
        }
        console.log()
        calculate_size(where_is_finder)
      }

      setTimeout(function(){ 
        $(".find-size__group .select-style .fa-chevron-down.open").removeClass("open")
        $(".find-size__group .select-style.open").removeClass("open")
      }, 250);

    })
  

    $(".tag_find_size__num").on("click", function(e){
console.log("open tag_find_size__num")
      var where_is_finder = $(this).attr("attr-where-is")

      e.preventDefault();

      var size_num_parent = $(this).parent()
  
      finder_size_num = $(this).attr("attr-find")
      $(".tag_find_size__num").removeClass("selected")
      $(this).addClass("selected")
      $(this).prependTo(size_num_parent)
  
      if ((finder_size_type !== "") && (finder_size_gender !== "") && (finder_size_num !== "")) {
        if(finder_opened) {
          finder_size_gender = gender_tag
        } else {
          finder_size_gender = $(".product-single__meta__find-size .find-size__group").attr("attr-find")
        }
        calculate_size(where_is_finder)
      }
  
      setTimeout(function(){ 
        $(".find-size__num.select-style.active.open").removeClass("open")
        $(".find-size__num.select-style.active .fa-chevron-down").removeClass("open")
      }, 250);

    })
  }


  // PDP Finder Size - 2
  $(".find-size .square-size").on("click", function(){

    var where_is_finder = $(this).attr("attr-where-is")

    var val_select_size = $(this).attr("attr-value")

    if (val_select_size == "Small") {
      val_select_size__convert = "Small"
    } 
    else if (val_select_size == "Medium") {
      val_select_size__convert = "Medium"
    } 
    else if (val_select_size == "Large") {
      val_select_size__convert = "Large"
    } 
    else if ((val_select_size == "ExtraSmall") || (val_select_size == "Extra Small") || (val_select_size == "X-Small")) {
      val_select_size__convert = "Extra Small"
    } 
    else if ((val_select_size == "ExtraLarge") || (val_select_size == "Extra Large") || (val_select_size == "X-Large")) {
      val_select_size__convert = "Extra Large"
    } 
    else if (val_select_size == "OSFM") {
      val_select_size__convert = "OSFM"
    }
    else if (val_select_size == "Mini") {
      val_select_size__convert = "Mini"
    }
    else if (val_select_size == "One") {
      val_select_size__convert = "One"
    }
    else if (val_select_size == "154") {
      val_select_size__convert = "154"
    }
    else if (val_select_size == "157") {
      val_select_size__convert = "157"
    }
    else if (val_select_size == "160") {
      val_select_size__convert = "160"
    }

    $(".find-size."+where_is_finder+" .square-size").addClass("hide")
    $(this).removeClass("hide")

    $(".find-size .square-size").removeClass("selected")
    $(this).addClass("selected")

    $(".variations-sizes .square-size").removeClass("selected")
    $(".variations-sizes .square-size[attr-value='"+val_select_size__convert+"']").addClass("selected")

    $(".variant-size .single-option-selector").val(val_select_size__convert)
    
  })


  $(".section-specifications__features .spec_pin").on("click", function(){
    var feature_selected = $(this).attr("attr-spec")
    $(".section-specifications__info").addClass("hide")
    $(".section-specifications__info[attr-spec='"+feature_selected+"']").removeClass("hide")

    $(".spec_pin").removeClass("selected")
    $(this).addClass("selected")

  })

  $(".find-size-text img.arrow-down").on("click", function(){

    if ( $(this).hasClass("closed") ) {
      $(this).removeClass("closed")
      $(".find-size.product-single__meta__find-size").removeClass("closed")
    } else {
      $(this).addClass("closed")
      $(".find-size.product-single__meta__find-size").addClass("closed")
    }
  })


}



// PLP *****************************************************************************************************************************************************************
var plp = function($){

    // PLP Scripts
    if ($(".template-collection").length) {

      // PLP - Sorting menu
      let searchParams = new URLSearchParams(window.location.search)
      if( searchParams.has('sort_by') ) {
        let param = searchParams.get('sort_by')
        $(".sorting-option").removeClass("selected")
        $(".sorting-option[attr-sort='"+param+"']").addClass("selected")
      }
      
      // PLP - Save existing sort parameters
      Shopify.queryParams = {};
      if(location.search.length) {
          for(var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
              if (aKeyValue.length > 1) {
                  Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
              }
          }
      }
  
      // PLP Sorting
      $(".sorting-option").on("click", function(){
        $(".sorting-option").removeClass("selected")
        $(this).addClass("selected")
        var attr_sort = $(this).attr("attr-sort")
        Shopify.queryParams.sort_by = attr_sort;
        location.search = new URLSearchParams(Shopify.queryParams).toString();
      })
  
      // PLP - Box filter - hide/show
      $(".filter-box h4").on("click", function(){
        if( $(this).parent().hasClass("opened") ) {
          $(this).parent().removeClass("opened")
          $(this).parent().find(".icon.icon-chevron-down").addClass("closed")
          // $(this).addClass("closed")
        } else {
          $(this).parent().addClass("opened")
          $(this).parent().find(".icon.icon-chevron-down").removeClass("closed")
          // $(this).removeClass("closed")
        }
      })
  
      // PLP - check filtri già applicati
      var filter_values = []
      var current_collection = $(".filters-box").attr("attr-collection")
      var path_uri = window.location.pathname
      if(path_uri.endsWith("/")) {
        path_uri = path_uri.slice(0,-1)
      }
      var col_path = path_uri.split('/')
      var col_pat__filter = col_path[col_path.length-1]
      var filter_items_url = col_pat__filter.split('+')

      // check availability filter
      // if (localStorage.page_on_click_availability) {
      //   if ( 
      //     (localStorage.page_on_click_availability == window.location.pathname) 
      //     || 
      //     (localStorage.page_on_click_availability.indexOf("collections/union-snowboard-bindings") >= 0)
      //     ) {
      //     // if (localStorage.only_available_products == "true") {
      //     //   $(".filter-box[attr-type-filter='availability'] input#available").trigger("click")
      //     //   $(".filter-box[attr-type-filter='availability'] .icon.icon-chevron-down.closed").trigger("click")
      //     //   show_only_available()
      //     // } else {
      //     //   localStorage.only_available_products = false
      //     // }
          
      //     // $(".filter-box[attr-type-filter='availability'] input#available").trigger("click")
      //     // $(".filter-box[attr-type-filter='availability'] .icon.icon-chevron-down.closed").trigger("click")
      //     show_only_available()
      //   }
      // }

      // PLP - Se la url contiene dei filtri allora flaggo le relative caselle
      if (
          (col_pat__filter.includes("+"))
          ||
          (col_path[col_path.length-2] == current_collection) // per il caso di un singolo filtro nella uri (che non contiene il + quindi)
        ) {
  
        filter_items_url.forEach(function(e){
  
          var item_to_search = e
  
          if (item_to_search!== "") {
            if ( item_to_search.includes("%20") == true ) {
              item_to_search = item_to_search.replace("%20", " ")
            }
            filter_values.push(item_to_search)
          }

          // console.log(item_to_search)
  
          if ((item_to_search == "Unisex") || (item_to_search == "unisex") || (item_to_search == "collaborations") || (item_to_search == "Collaborations")) {
            $(".filter-box input[value='All']").prop('checked', false);
          }

          switch (true) {
            case item_to_search == "men":
              item_to_search = "Men"
            break;
            case item_to_search == "women":
              item_to_search = "Women"
            break;
            case item_to_search == "kids":
              item_to_search = "Kids"
            break;
            case item_to_search == "unisex":
              item_to_search = "Unisex"
            break;
          }
          // Filtri con input
          $(".filter-box input").each(function(){
            if( $(this).attr("value") == item_to_search ) {
              $(this).prop('checked', true);
              var attr_type_filter = $(this).attr("attr-type-filter")
              $(".filter-box[attr-type-filter='"+attr_type_filter+"'] .icon.icon-chevron-down.closed").trigger("click")
            }
          })
  
          // Filtro size
          $(".filter-box .variations-sizes .square-size").each(function(){
            if( $(this).attr("attr-value") == item_to_search ) {
              $(this).addClass('selected');
              $(".filter-box[attr-type-filter='size'] .icon.icon-chevron-down.closed").trigger("click")
            }
          })
  
          // Filtro color
          $(".filter-box .round-color").each(function(){
            if( $(this).attr("attr-value") == item_to_search ) {
              $(this).find("i").removeClass('hide');
              $(".filter-box[attr-type-filter='color'] .icon.icon-chevron-down.closed").trigger("click")
            }
          })

        })
      }
  
      // PLP - mostro il numerino di elementi nel filtro nel mobile
      function filter_empty_active(num) {
        if(num>0) {
          $(".plp-filter-button-empty__active").css("display","block")
          $(".plp-filter-button-empty__num").text(num)
        } else {
          $(".plp-filter-button-empty__active").css("display","none")
        }
      }
  
      // PLP - creo la stringa per filtrare
      function filter_create_query(filter_values) {
        if (filter_values.length >= 1) {
          var query = filter_values.join('+')
        } else {
          var query = ""
        }
        return query
      }
  
      // PLP - Box filter - filter products input
      $(".filter-box").not(".filter-box--availability").not(".filter-box--products").find("input").on("click", function(){
  
        var attr_type = $(this).attr("attr-type-filter")
        var attr_value = $(this).attr("value")

        if (attr_value == "Men") {
          window.location.href = '/collections/mens-union-snowboard-bindings/'
          return;
        } else if (attr_value == "Women") {
          window.location.href = '/collections/womens-union-snowboard-bindings/'
          return;
        } else if (attr_value == "Unisex") {
          window.location.href = '/collections/union-snowboard-bindings/Unisex'
          return;
        } else if (attr_value == "Kids") {
          window.location.href = '/collections/kids-union-snowboard-bindings/'
          return;
        } else if (attr_value == "Collaborations") {
          window.location.href = '/collections/union-snowboard-bindings/Collaborations'
          return;
        } else if (attr_value == "All") {
          window.location.href = '/collections/union-snowboard-bindings'
          return;
        }

        $(".filter-box input[attr-type-filter='"+attr_type+"']").each(function(){
          if ($(this).is(':checked')) {
            var filter_value_to_remove = $(this).attr("value")
            filter_values = filter_values.filter(item => item !== filter_value_to_remove)
          } 
        })

        if (!$(this).is(':checked')) {
          var filter_value_to_remove = $(this).attr("value")
          filter_values = filter_values.filter(item => item !== filter_value_to_remove)
        } else {
          var filter_value_to_add = $(this).attr("value")
          filter_values.push(filter_value_to_add)
        }
  
        var query = filter_create_query(filter_values) 
  
        if (window.innerWidth > 991) {
          window.location.href = '/collections/'+current_collection+'/' + query
        } else {
          filter_empty_active(filter_values.length)
        }
  
      })

      function show_only_available() {
        $(".collection-section .grid__item").each(function(){
          if ( $(this).attr("attr-available") == "false" ) {
            $(this).addClass("hide")
          }
        })
        if ($(".collection-section__content .grid--view-items .grid__item").not(".hide").length == 0) {
          if ($(".collection-section .grid__item.small--text-center.no_matches").length == 0) {
            $(".collection-section__content").append(
                `<div class="grid__item small--text-center no_matches no_matches-available">
                  <p class="text-center">Sorry, there are no products in this collection</p>
                </div>
              `)
          }
        } else {
          $(".collection-section .grid__item.small--text-center.no_matches.no_matches-available").remove()
        }
      }
      
      function show_only_available_by_size(size_value_search) {
        $(".collection-section .grid__item").each(function(){

          let item_prod = $(this)
          $($(this).find(".square-size")).each(function(){

            let size_value_square = $(this).attr("attr-value")

            if (size_value_search == size_value_square) {
              if ( !$(this).hasClass("sold-out") ) {
                item_prod.removeClass("hide")
              }
            } 
          })
          if ( $(this).attr("attr-available") == "false" ) {
            $(this).addClass("hide")
          }
        })

      }

      // PLP - Box filter - filter availability
      $(".filter-box--availability").find("input#available").on("click", function(event){

        // localStorage.page_on_click_availability = window.location.pathname

        $(".filter-box--availability").find("input.available_by_size").each(function(){
          $(this).prop('checked', false); 
        })
        // mostro tutto
        $(".collection-section .grid__item").each(function(){
          $(this).removeClass("hide")
        })

        if ($(this).is(":checked")) {
          show_only_available()
          // localStorage.only_available_products = true
        } else {
          $(".collection-section .grid__item").each(function(){
            $(this).removeClass("hide")
          })
          // localStorage.only_available_products = false
        }
      })

      // PLP - Box filter - filter availability by size
      $(".filter-box--availability").find("input.available_by_size").on("click", function(event){

        // valore da cercare
        let size_value_search = $(this).attr("value") 

        // deflaggo tutto tranne quello cercato
        $(".filter-box--availability").find("input").not("[value='"+size_value_search+"']").each(function(){
          $(this).prop('checked', false); 
        })

        // nascondo tutto
        $(".collection-section .grid__item").each(function(){
          $(this).addClass("hide")
        })

        // se sto flaggando cerco
        if ($(this).is(":checked")) {
          show_only_available_by_size(size_value_search)
        } else {
          $(".collection-section .grid__item").each(function(){
            $(this).removeClass("hide")
          })
        }
      })

      // PLP - Box filter - filter products
      $(".filter-box--products").find("input").on("click", function(event){

        $(".filter-box--availability").find("input").each(function(){
          $(this).prop('checked', false); 
        })
      
        let handle_product = $(this).attr("value")
        let input_this = $(this)

        $(".collection-section .grid__item").each(function(){

          let handle_grid = $(this).attr("attr-handle")
          let grid_this = $(this)
          
          if (handle_grid == handle_product) {
            if (input_this.is(":checked")) {
              $(this).removeClass("hide")
            } else {
              $(this).addClass("hide")
            }
          } else {
            $(".filter-box--products").find("input").each(function(){
              let other_handle_product = $(this).attr("value")
              if (handle_grid == other_handle_product) {
                if ($(this).is(":checked")) {
                  grid_this.removeClass("hide")
                } else {
                  grid_this.addClass("hide")
                }
              }
            })
          }
        })

        // if no product filtred show all
        let at_least_one_product_filtred = false
        $(".filter-box--products").find("input").each(function(){
          if ($(this).is(":checked")) {
            at_least_one_product_filtred = true
            // console.log($(this).attr("value"))
          } 
        })
        if (!at_least_one_product_filtred) {
          $(".collection-section .grid__item").each(function(){
            $(this).removeClass("hide")
          })
        }

      })

      // PLP - Box filter - filter products size
      $(".filter-box .variations-sizes .square-size").on("click", function(){
  
        if ($(this).hasClass('selected')) {
          $(this).removeClass("selected")
          var filter_value_to_remove = $(this).attr("attr-value")
          filter_values = filter_values.filter(item => item !== filter_value_to_remove)
        } else {
          $(this).addClass("selected")
          var filter_value_to_add = $(this).attr("attr-value")
          filter_values.push(filter_value_to_add)
        }
  
        var query = filter_create_query(filter_values) 
     
        if (window.innerWidth > 991) {
          window.location.href = '/collections/'+current_collection+'/' + query
        } else {
          filter_empty_active(filter_values.length)
        }
  
      })
  
      // PLP - Box filter - filter products color
      $(".filter-box .round-color").on("click", function(){
  
        if (!$(this).find("i").hasClass('hide')) {
          $(this).find("i").addClass('hide')
          var filter_value_to_remove = $(this).attr("attr-value")
          filter_values = filter_values.filter(item => item !== filter_value_to_remove)
        } else {
          $(this).find("i").removeClass('hide')
          var filter_value_to_add = $(this).attr("attr-value")
          filter_values.push(filter_value_to_add)
        }
  
        var query = filter_create_query(filter_values) 
        
        if (window.innerWidth > 991) {
          window.location.href = '/collections/'+current_collection+'/' + query
        } else {
          filter_empty_active(filter_values.length)
        }
  
      })
  
      // PLP - filter mob
      $(".plp-filter-button").on("click", function(){
        $("header.collection-header").addClass("show")
  
        // nella filter_values c'è anche la collection, quindi creo un array uguale ma senza la collection per contare gli elemtni attivi
        fv = filter_values
        fv = fv.filter(item => item !== current_collection)
  
        filter_empty_active(fv.length)
      })
      $(".plp-filter-close").on("click", function(){
        $("header.collection-header").removeClass("show")
      })
      $(".plp-filter-button-search").on("click", function(){
        var query = filter_create_query(filter_values) 
        window.location.href = '/collections/'+current_collection+'/' + query
      })
  
      // PLP - delete filters checkbox/size/colours
      $(".plp-filter-button-empty").on("click", function(){
        filter_values = []
        query = ""
        $( ".filters-box input" ).prop( "checked", false );
        $(".square-size.selected").removeClass("selected")
        $(".round-color i").addClass('hide')
        filter_empty_active(filter_values.length)
      })
  
      // PLP - open compare
      $(".section-compare__title").on("click", function() {
  
        if ( $(".section-compare").hasClass("opened") ) {
          $(this).removeClass("opened")
          $(".section-compare").removeClass("opened")
        } else {
          $(this).addClass("opened")
          $(".section-compare").addClass("opened")
        }
      })
  
    }

}



// DISK COMPATIBILITY *****************************************************************************************************************************************************************
var disk_compatibility = function($){

  if ($(".page-disk").length) {

    var array_disk = {
      "type-2x4": [
        "camber-disk",
        "universal-disk",
        "mini-disk",
        "explorer-q-disk",
        "charger-q-disk"
      ],
      "type-4x4": [
        "camber-disk",
        "universal-disk"
      ],
      "type-3d": [
        "universal-disk"
      ],
      "type-channel": [
        "camber-disk",
        "mini-disk",
        "universal-disk"
      ],
      "type-burton-split": [
      ],
      "type-voile-split": [
        "explorer-disk",
        "charger-disk"
      ]
    }

    $(".box-type").on("click", function(){
      $(".box-type").removeClass("selected")
      $(this).addClass("selected")

      var attr_type = $(this).attr("attr-type")
      var disk_to_show = array_disk[attr_type]

      $(".box-disk").addClass("hide")
      
      for (var disk in disk_to_show ) {
        $(".box-disk[attr-type='"+disk_to_show[disk]+"']").removeClass("hide")
      }

      $([document.documentElement, document.body]).animate({
          scrollTop: $("#compatible-disk").offset().top
      }, 1000);


    })
  }

}




// HOUSE *****************************************************************************************************************************************************************
var house = function($){

  if ($(".page-house").length) {

    $(".collaborations-box__single").each(function(){

      var col_box = $(this)
      var date_start = $(this).attr("data-time")

      if (typeof date_start !== typeof undefined && date_start !== false) {

        // Set the date we're counting down to
        var countDownDate = new Date(date_start).getTime();
    
        // Update the count down every 1 second
        var x = setInterval(function() {

            // jQuery.ajax({
            //   url:"/pages/finder-list?view=date-now", 
            //   success:function(date){
            //     now = new Date(date).getTime();
            //   }
            // })

            var now = new Date().getTime();

            // Find the distance between now and the count down date
            var distance = countDownDate - now;
    
            if (distance == 0) {
              clearInterval(x);
              col_box.find("img").css("opacity","1")
              col_box.find(".countdown").html("")
            }
            if (distance < 0) {
                clearInterval(x);
                col_box.find("img").css("opacity","1")
                col_box.find(".countdown").html("")
            }

            if (distance > 0) {

              col_box.find("img.collaborations-box__single__img").css("opacity","0.5")

              // Time calculations for days, hours, minutes and seconds
              var days = Math.floor(distance / (1000 * 60 * 60 * 24));
              var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
              days = String(days)
              if (days.length == 1 ) {
                  days = '0' + days;
              }
              hours = String(hours)
              if (hours.length == 1 ) {
                  hours = '0' + hours;
              }
              minutes = String(minutes)
              if (minutes.length == 1 ) {
                  minutes = '0' + minutes;
              }
              seconds = String(seconds)
              if (seconds.length == 1 ) {
                  seconds = '0' + seconds;
              }
              
              col_box.find(".countdown").html(`
                  <div class="countdown-time">
                      <div class="countdown-time__num">
                          <span>
                              ` + days + `<br/>
                            <span class="countdown-time__text">
                                DAYS
                            </span>
                          </span>
                          
                          <span>
                              ` + hours + `<br/>
                              <span class="countdown-time__text">
                                HOURS
                              </span>
                          </span>
                          
                          <span>
                              ` + minutes + `<br/>
                              <span class="countdown-time__text">
                                MINUTES
                              </span>
                          </span>
                          
                          <span>
                              ` + seconds + `<br/>
                              <span class="countdown-time__text">
                                SECONDS
                              </span>
                          </span>
                      </div>
                  </div>
              `)
            }

        }, 1000);

      }

    })

    $(".vault-box__single").on("click", function(){


      var attr_close = $(this).attr("attr-close")
      var attr_img1 = $(this).attr("attr-img1")
      var attr_img2 = $(this).attr("attr-img2")
      var attr_img3 = $(this).attr("attr-img3")
      var attr_img4 = $(this).attr("attr-img4")
      var attr_title = $(this).attr("attr-title")
      var attr_text = $(this).attr("attr-text")

      var modal_slider_vault = `
      
      <div class="modal-big-vault">

          <img class="close-vault" src="`+attr_close+`" alt="close vault">

          <div class="swiper-container modal-big-vault__swiper-container">
            <div class="swiper-wrapper">

              <div class="swiper-slide">
                <img src="`+attr_img1+`" alt="slider union vault">
              </div>
              <div class="swiper-slide">
                <img src="`+attr_img2+`" alt="slider union vault">
              </div>
              <div class="swiper-slide">
                <img src="`+attr_img3+`" alt="slider union vault">
              </div>
              <div class="swiper-slide">
                <img src="`+attr_img4+`" alt="slider union vault">
              </div>

            </div>

            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>

            <div class="swiper-pagination"></div>

          </div>

          <div class="modal-big-vault__text">
            <strong>`+attr_title+`</strong>
            <p>`+attr_text+`</p>
          </div>

      </div>


      `

      // console.log(modal_slider_vault)

      $("body").append(modal_slider_vault)

      var modal_big_vault__swiper_container = new Swiper(".modal-big-vault__swiper-container", {
        slidesPerView: 1,
        navigation: {
          nextEl: ".modal-big-vault__swiper-container .swiper-button-next",
          prevEl: ".modal-big-vault__swiper-container .swiper-button-prev",
        },        
        pagination: {
          el: ".modal-big-vault__swiper-container .swiper-pagination",
        },
        // observer: true,
        // observeParents: true
      });


      $(".close-vault").on("click", function(){
        $(".modal-big-vault").remove()
      })

    })



  }
}







// TECH page *****************************************************************************************************************************************************************
var newtech = function($){

  if ($(".page-newtech").length) {

    $(".arrow-down-mob").on("click", function() {
      var attr_box = $(this).attr("attr-box")

      if ($(".tech-box[attr-box='"+attr_box+"']").hasClass("opened")) {
        $(".tech-box[attr-box='"+attr_box+"']").removeClass("opened")
        $(this).removeClass("opened")
      } else {
        $(".tech-box[attr-box='"+attr_box+"']").addClass("opened")
        $(this).addClass("opened")
      }

    })

  }

}



// INSTALLATION page *****************************************************************************************************************************************************************
var installation = function($){

  if ($(".installation-page").length) {

    $(".section-selection .box-rounded").on("click", function() {
      
      $(".section-selection .box-rounded").removeClass("selected")
      $(this).addClass("selected")

      var video_list_type = $(this).attr("attr-type")

      $(".installation-video-steps").addClass("hide")
      $(".installation-video-steps[attr-type='"+video_list_type+"']").removeClass("hide")
    
      $(".installation-guide").addClass("hide")
      $(".installation-guide[attr-type='"+video_list_type+"']").removeClass("hide")

      $(".cta").addClass("hide")
      $(".cta cta-black[attr-type='"+video_list_type+"']").removeClass("hide")

      $([document.documentElement, document.body]).animate({
          scrollTop: $("#section-installation-selection").offset().top
      }, 1000);
      
    })


    var installation_video_standard = new Swiper(".video-container-standard .swiper-container", {
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: ".video-container-standard .swiper-button-next",
        prevEl: ".video-container-standard .swiper-button-prev",
      },
      // observer: true,
      // observeParents: true,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 30
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      }
    });

    var installation_video_splitboard = new Swiper(".video-container-splitboard .swiper-container", {
      slidesPerView: 3,
      spaceBetween: 30,
      centeredSlides: true,
      navigation: {
        nextEl: ".video-container-splitboard .swiper-button-next",
        prevEl: ".video-container-splitboard .swiper-button-prev",
      },
      // observer: true,
      // observeParents: true,
      breakpoints: {
        320: {
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 20
        },
        480: {
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 30
        },
        640: {
          slidesPerView: 3,
          centeredSlides: true,
          spaceBetween: 40
        }
      }
    });

    var installation_video_skins = new Swiper(".video-container-skins .swiper-container", {
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: ".video-container-skins .swiper-button-next",
        prevEl: ".video-container-skins .swiper-button-prev",
      },
      // observer: true,
      // observeParents: true,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
          slidesPerView: "auto"
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 30,
          slidesPerView: "auto"
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 40,
          slidesPerView: "auto"
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      }
    });



    $(".installation-guide--openclose").on("click", function(){

      if ( $(this).attr("attr-status") == "closed" ) {
        $(this).attr("attr-status","opened")
        $(".installation-guide").attr("attr-status","opened")
      } else {
        $(this).attr("attr-status","closed")
        $(".installation-guide").attr("attr-status","closed")
      }
    })

    // if ( screen.width < 991 ) {
    //   $(".installation-guide--openclose").attr("attr-status","closed")
    //   $(".installation-guide").attr("attr-status","closed")
    // }

  }

}



// WARRANTY page *****************************************************************************************************************************************************************
var warranty = function($){

  if ($(".warranty-page").length) {

    $(".section-selection .box-rounded").on("click", function() {

      var attr_type = $(this).attr("attr-type")

      $([document.documentElement, document.body]).animate({
          scrollTop: $(".anchor-section[attr-type='"+attr_type+"']").offset().top
      }, 1000);
      
    })

    $("button#is-covered").on("click", function(){
      var is_covered = $(".form--binding-covered #covered").val()

      // console.log(is_covered)

      $(".warranty-box").addClass("hide")
      $(".warranty-box[attr-covered='"+is_covered+"']").removeClass("hide")
    })


      // find Local Dealer Name
      $(':input#search--authorized_1').bind('propertychange input', function (e) {

          e.preventDefault();

          $(".search--authorized__finded").empty(); 

          var valueChanged = false;
      
          if (e.type=='propertychange') {
              valueChanged = e.originalEvent.propertyName=='value';
          } else {
              valueChanged = true;
          }
          if (valueChanged) {
            
              var text_to_search = $(this).val().toLowerCase()

              if (text_to_search.length > 2 ) {

                jQuery.ajax({
                  url:"/pages/finder-list?view=warranty-local-dealer.json", 
                  success:function(local_dealer){
              
                    $(".finded-deal").remove(); 

                    var finded = false
                    var name_finded = ""
                    var adr_finded = ""
                    var region_finded

                    var local_dealer_parse = JSON.parse(local_dealer)
            
                    for (var dealer of Object.keys(local_dealer_parse)) {

                      finded = false
                      name_finded = ""
                      adr_finded = ""
                      region_finded = ""
            
                        // console.log(local_dealer_parse[dealer])

                        if (local_dealer_parse[dealer][0].toLowerCase().indexOf(text_to_search) >= 0) {
                          finded = true
                          name_finded = dealer
                          region_finded = local_dealer_parse[dealer][0]
                          adr_finded = local_dealer_parse[dealer][1]
                        }

                        if (local_dealer_parse[dealer][1].toLowerCase().indexOf(text_to_search) >= 0) {
                          finded = true
                          name_finded = dealer
                          region_finded = local_dealer_parse[dealer][0]
                          adr_finded = local_dealer_parse[dealer][1]
                        }


                      if ( finded ) {
                        $(".search--authorized__finded").append(
                          "<span class='finded-deal' attr-name='"+name_finded+"' attr-address='"+adr_finded+"' attr-region='"+region_finded+"'>"+name_finded+"</span>"
                        )
                      }
                      
                    }
            
                    $(".finded-deal").on("click", function(){
                      var name_deal_selected = $(this).attr("attr-name")
                      var adr_deal_selected = $(this).attr("attr-address")
                      var region_deal_selected = $(this).attr("attr-region")

                      $(".local-dealer__name").text(name_deal_selected)
                      $(".local-dealer__region").text(region_deal_selected)
                      $(".local-dealer__adr__row1").text(adr_deal_selected)

                      $(".finded-deal").remove();

                    })
                    
                  }
                })
                
              }
          }
      });




  }

}







// ROVER page *****************************************************************************************************************************************************************
var rover = function($){

  if ($(".template--product--rover").length) {

    $(".video-rover-text .btn").on("click", function() {

      $(".video-rover-text").addClass("hide")
      $(".section-video-rover").addClass("video-visible")

      if (window.innerWidth > 768 ) { 
        $(".rover-video").removeClass("hide")
        $("#rover-video").get(0).play()
      } else {
        $(".rover-video-mob").removeClass("hide")
        $("#rover-video-mob").get(0).play()
      }

    })

  }

}





// HOW TO VIDEOS page *****************************************************************************************************************************************************************
// var howtovideos = function($){

//   if ($(".page-howtovideos").length) {

//     $(".howtovideo-head").on("click", function() {

//       if ( $(this).hasClass("opened") ) {
//         $(this).parent().removeClass("opened")
//         $(this).removeClass("opened")
//       } else {
//         $(this).parent().addClass("opened")
//         $(this).addClass("opened")
//       }

//     })

//     let urlParamshowtovideos = new URLSearchParams(window.location.search)
//     // console.log(urlParamshowtovideos)
//     if( urlParamshowtovideos.has('viewVideo') ) {
//       let param_size = urlParamshowtovideos.get('viewVideo')
//       // console.log(param_size)
//       $(".howtovideo-head.opened").trigger("click")
//       $(".howtovideo-head[attr-view='"+param_size+"']").trigger("click")
//       $('html,body').animate({
//         scrollTop: $(".howtovideo-head[attr-view='"+param_size+"']").offset().top
//       },'slow');
//     }


//   }

// }



// HOW TO VIDEOS page *****************************************************************************************************************************************************************
var help = function($){

  if ($(".page-help").length) {

    $(".help-toggle-nav").on("click", function() {

        $(".help-toggle-content").removeClass("selected")
        $(".help-toggle-nav").removeClass("selected")

        var toggle_id = $(this).attr("attr-box")
        $(".help-toggle-content[attr-box='"+toggle_id+"']").addClass("selected")
        $(this).addClass("selected")

        // if (window.innerWidth < 769 ) { 

        //     $(this).prependTo(".help-toggle-head-mob")
        //     $(".help-toggle-head-mob").removeClass("open")
        //     $(".help-toggle-head-mob .fas").removeClass("open")
        // }

    })

    let urlParamshelp = new URLSearchParams(window.location.search)
    if( urlParamshelp.has('viewHelp') ) {
      let param_size = urlParamshelp.get('viewHelp')
      // console.log(param_size)
      $(".help-toggle-nav[attr-type='"+param_size+"']").trigger("click").addClass("selected")
      $('html,body').animate({
        scrollTop: $("#anchor-help").offset().top
      },'slow');
    }


  }

}



// COOKIE Tool *****************************************************************************************************************************************************************
var cookie = function($){


    // Il link footer #cookie-tool riapre Consentmo via markup (class isense-reopen-widget-button + onclick) in footer.liquid


}


// MODAL COUNTRY *****************************************************************************************************************************************************************
var modalCountry = function($){

  let urlParams = new URLSearchParams(window.location.search)
  if( urlParams.has('jump-location') ) {
    switch (sessionStorage.getItem("geo-location")) {
      case "eu":
        window.location.replace("https://eu.unionbindingcompany.com"+window.location.pathname);
      break;
      case "jp":
        window.location.replace("https://jp.unionbindingcompany.com"+window.location.pathname);
      break;
      case "aus":
        window.location.replace("https://aus.unionbindingcompany.com"+window.location.pathname);
      break;
      case "nz":
        window.location.replace("https://aus.unionbindingcompany.com/en-nz"+window.location.pathname);
      break;
    }
  }

  if (sessionStorage.getItem("modalCountry") == "close") {
    $("#choose-country-site-modal").addClass("hide")
  }

  $("#choose-country-site-modal .fas.fa-times-circle").on("click", function() {
    $("#choose-country-site-modal").addClass("hide")
    sessionStorage.setItem("modalCountry", "close")
  })
  $("#choose-country-site-modal .btn-no").on("click", function() {
    $("#choose-country-site-modal").addClass("hide")
    sessionStorage.setItem("modalCountry", "close")
  })

  if (sessionStorage.getItem("checkCountry") == "not-us") {
    $(".product-form").addClass("hide")
    $(".product__price").addClass("hide")
    $(".price--listing").addClass("hide")
  }
  if (sessionStorage.getItem("checkCountry") == "not-eu") {
    $(".product-form").addClass("hide")
    $(".product__price").addClass("hide")
    $(".price--listing").addClass("hide")
  }
  setInterval(function(){ 
    if (sessionStorage.getItem("checkCountry") == "not-us") {
      $(".product-form").addClass("hide")
      $(".product__price").addClass("hide")
      $(".price--listing").addClass("hide")
    } 
    if (sessionStorage.getItem("checkCountry") == "not-eu") {
      $(".product-form").addClass("hide")
      $(".product__price").addClass("hide")
      $(".price--listing").addClass("hide")
    } 
  }, 1000);

}



// CURRENCY *****************************************************************************************************************************************************************
var currency = function($){

  $( document ).ready(function() {
    
    $(".site-footer__content .currency-selector").appendTo(".currency-header");

  });

}


// DISTRIBUTOR page *****************************************************************************************************************************************************************
var distributor = function($){

  if ($(".template-distributor").length) {

    $(".distributor-head").on("click", function() {

      if ( $(this).hasClass("opened") ) {
        $(this).parent().removeClass("opened")
        $(this).removeClass("opened")
      } else {
        $(this).parent().addClass("opened")
        $(this).addClass("opened")
      }

    })
  }
}


// EVENTS page *****************************************************************************************************************************************************************
var events = function($){

  if ($(".events-section").length) {

    $(".js-events-toggle").on("click", function() {

      if ( $(this).hasClass("opened") ) {
        $(this).parent().removeClass("opened")
        $(this).removeClass("opened")
      } else {
        $(this).parent().addClass("opened")
        $(this).addClass("opened")
      }

    })

  }
}


// STORES page *****************************************************************************************************************************************************************
var stores = function($){

  if ($(".stores-section").length) {

    $(".js-stores-toggle").on("click", function() {

      if ( $(this).hasClass("opened") ) {
        $(this).parent().removeClass("opened")
        $(this).removeClass("opened")
      } else {
        $(this).parent().addClass("opened")
        $(this).addClass("opened")
      }

    })

  }
}


// controllo jQuery
if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
  loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
    jQuery191 = jQuery.noConflict(true);
    finder(jQuery191);
    compare(jQuery191);
    header(jQuery191);
    footer(jQuery191);
    home(jQuery191);
    pdp(jQuery191);
    plp(jQuery191);
    disk_compatibility(jQuery191);
    house(jQuery191);
    newtech(jQuery191);
    installation(jQuery191);
    warranty(jQuery191);
    rover(jQuery191);
    // howtovideos(jQuery191);
    help(jQuery191);
    cookie(jQuery191);
    modalCountry(jQuery191);
    currency(jQuery191);
    distributor(jQuery191);
    events(jQuery191);
    stores(jQuery191);
  });
} else {
  finder(jQuery);
  compare(jQuery);
  header(jQuery);
  footer(jQuery);
  home(jQuery);
  pdp(jQuery);
  plp(jQuery);
  disk_compatibility(jQuery);
  house(jQuery);
  newtech(jQuery);
  installation(jQuery);
  warranty(jQuery);
  rover(jQuery);
  // howtovideos(jQuery);
  help(jQuery);
  cookie(jQuery);
  modalCountry(jQuery);
  currency(jQuery);
  distributor(jQuery);
  events(jQuery);
  stores(jQuery);
}
  